/** Ortak ve hata metinleri (tr); panel, vitrin ve API birlikte kullanır (F7-17'de ayrıldı). */
import { faz8ErrorsTr } from './faz8.tr';
import { aiErrorsTr } from './ai.errors.tr';

export const commonTr = {
  appName: 'Zootopia Panel',
  save: 'Kaydet',
  cancel: 'Vazgeç',
  done: 'Tamam',
  delete: 'Sil',
  edit: 'Düzenle',
  create: 'Oluştur',
  add: 'Ekle',
  close: 'Kapat',
  back: 'Geri',
  previous: 'Önceki',
  next: 'İleri',
  confirm: 'Onayla',
  loading: 'Yükleniyor…',
  saved: 'Kaydedildi',
  yes: 'Evet',
  no: 'Hayır',
  none: 'Yok',
  all: 'Tümü',
  status: 'Durum',
  actions: 'İşlemler',
  name: 'Ad',
  email: 'E-posta',
  password: 'Şifre',
  search: 'Ara',
  copy: 'Kopyala',
  copied: 'Kopyalandı',
  optional: 'isteğe bağlı',
  required: 'zorunlu',
  noData: 'Henüz veri yok',
  unknown: 'Bilinmiyor',
  retry: 'Tekrar dene',
  help: 'Yardım',
  whatIsThisPage: 'Bu sayfa ne işe yarar?',
  lockedPhase: '{{phase}}. fazda açılacak',
  createdAt: 'Oluşturulma',
  updatedAt: 'Güncelleme',
  lastUsed: 'Son kullanım',
  never: 'Hiç',
  signOut: 'Çıkış yap',
  modeBeginner: 'Başlangıç modu',
  modeAdvanced: 'Gelişmiş mod',
  language: 'Dil',
  theme: 'Tema',
  themeLight: 'Açık',
  themeDark: 'Koyu',
  themeSystem: 'Sistem',
  reveal: 'Göster',
  days: '{{count}} gün',
  more: 'Daha fazla',
  remove: 'Kaldır',
  deleted: 'Silindi',
} as const;

// Faz 8 hata metinleri ayrı dosyada; tek satırla eklenir (ADR-801).
export const errorsTr = {
  ...faz8ErrorsTr,
  ...aiErrorsTr,
  section_type_unavailable: 'Bu bölüm türü henüz kullanılamıyor.',
  section_target_missing: 'Seçilen kategori veya ürün bulunamadı; başka bir seçim yapın.',
  section_image_required: 'Bu bölüm için bir görsel yükleyin.',
  banner_image_required: 'Bu yerleşim için masaüstü görseli yükleyin.',
  question_too_short: 'Sorunuz en az 10 karakter olmalı.',
  question_answer_required: 'Yayımlamak için önce yanıt yazın.',
  favorites_full: 'Favori listeniz dolu (en fazla 200 ürün); yer açmak için birkaç ürünü çıkarın.',
  post_published_delete: 'Yayımlanmış yazı silinemez; yayından kaldırabilirsiniz.',
  post_body_required: 'Yayımlamak için yazının metnini girin.',
  banner_text_required: 'Bu yerleşim için metin yazın.',
  banner_image_not_allowed: 'Duyuru çubuğunda görsel kullanılmaz.',
  banner_link_required: 'Düğme metni için bir bağlantı adresi yazın.',
  end_before_start: 'Bitiş tarihi başlangıç tarihinden sonra olmalı.',
  banner_active_delete: 'Etkin banner silinemez; önce durdurun.',
  banner_order_mismatch:
    'Sıralama listesi bu yerleşimdeki bannerlarla uyuşmuyor; sayfayı yenileyip tekrar deneyin.',
  content_file_missing: 'İçerikteki bir görsel bulunamadı; görseli yeniden yükleyin.',
  unpublish_before_publish: 'Yayından kaldırma tarihi yayın tarihinden sonra olmalı.',
  page_home_exists: 'Bu mağazanın bu dilde zaten bir ana sayfası var.',
  locale_not_in_store:
    'Bu dil mağazanın pazarlarında yok. Önce Mağazalar ekranından bu dilde bir pazar ekleyin.',
  locale_unsupported: 'Bu dil desteklenmiyor (Türkçe, İngilizce, Almanca veya Arapça seçin).',
  translation_same_locale: 'Çeviri, içeriğin kendi dilinden farklı bir dil olmalı.',
  translation_exists: 'Bu içeriğin bu dilde zaten bir çevirisi var; dil süzgecinden açabilirsiniz.',
  content_locale_mismatch: 'Seçilen içerik başka bir dilde; bu dildeki sayfa, yazı veya kategoriyi seçin.',
  page_published_delete: 'Yayımlanmış sayfa silinemez (geçmişi korunur); yayından kaldırabilirsiniz.',
  content_review_required:
    'Sağlık içeriği veya sağlık beyanı var: yayımlamak için Veteriner Uzman İnceleyici onayı gerekir.',
  content_review_rejected: 'İçerik uzman incelemesinde reddedildi; düzeltip yeniden incelemeye gönderin.',
  content_review_not_required: 'Bu içerik için uzman onayı gerekmiyor.',
  invalid_item_id: 'Menü öğesi kimliği geçersiz; sayfayı yenileyip tekrar deneyin.',
  duplicate_item_id: 'Aynı menü öğesi iki kez eklenmiş; sayfayı yenileyip tekrar deneyin.',
  menu_too_deep: 'Menü bu konumda daha fazla iç içe olamaz (üst menü 3, alt bilgi 2 seviye).',
  menu_item_link_required: 'Alt öğesi olmayan menü öğesinin bir bağlantısı olmalı.',
  menu_too_many_items: 'Menüde en fazla 150 öğe olabilir.',
  menu_target_missing: 'Bağlantı verilen kategori veya ürün bulunamadı; başka bir hedef seçin.',
  theme_no_draft: 'Yayımlanacak bir tema taslağı yok. Önce taslağı kaydedin.',
  theme_draft_invalid: 'Tema taslağı okunamadı; editörde yeniden kaydedin.',
  theme_contrast_failed:
    'Tema yayımlanamaz: {{count}} renk çifti yeterince okunaklı değil. Editördeki uyarıları düzeltin.',
  theme_no_changes: 'Bu tema zaten yayında; değişiklik yok.',
  theme_dark_palette_required: 'Cihaza göre koyu görünüm için koyu renkler tanımlanmalı.',
  theme_preview_invalid: 'Önizleme bağlantısının süresi dolmuş veya geçersiz. Panelden yeni bağlantı alın.',
  store_domain_missing: 'Mağazanın vitrin alan adı tanımlı değil. Mağazalar ekranından alan adı ekleyin.',
  color_format: 'Renk #RRGGBB biçiminde olmalı (ör. #0d5a4e).',
  content_invalid: 'İçerik okunamadı; editörde yeniden kaydedin.',
  content_unknown_node: 'İçerikte izin verilmeyen bir öğe var (ör. yapıştırılan HTML veya betik).',
  content_invalid_link:
    'Bağlantı adresi geçersiz. https://…, mailto:, tel: veya / ile başlayan site içi adres kullanın.',
  content_image_alt_required:
    'Görselin ne gösterdiğini anlatan alternatif metin zorunlu (ekran okuyucular ve arama motorları için).',
  content_too_large: 'İçerik çok uzun. Metni birden çok sayfaya veya yazıya bölün.',
  content_too_deep: 'Liste çok fazla iç içe; en fazla 4 seviye kullanılabilir.',
  content_video_title_required: 'Video başlığı zorunlu (vitrinde oynatıcının adı olarak okunur).',
  invalid_section_id: 'Bölüm kimliği geçersiz.',
  duplicate_section_id: 'Aynı bölüm iki kez eklenmiş; sayfayı yenileyip tekrar deneyin.',
  section_category_required: 'Bu bölüm için bir kategori seçin.',
  section_collection_required: 'Bu bölüm için bir koleksiyon seçin.',
  section_brand_required: 'Bu bölüm için bir marka seçin.',
  section_products_required: 'Bu bölüm için en az bir ürün seçin.',
  unauthenticated: 'Oturum açmanız gerekiyor.',
  invalid_credentials: 'E-posta veya şifre hatalı.',
  account_locked: 'Çok fazla hatalı deneme. Hesap {{minutes}} dakika kilitlendi.',
  mfa_required: 'Doğrulama kodu gerekiyor.',
  mfa_setup_required: 'Devam etmek için iki adımlı doğrulamayı kurmalısınız.',
  mfa_invalid: 'Doğrulama kodu hatalı veya süresi dolmuş.',
  mfa_already_enrolled: 'İki adımlı doğrulama zaten kurulu.',
  mfa_enrollment_not_started: 'Önce doğrulama uygulaması kurulumunu başlatın.',
  step_up_required: 'Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor.',
  forbidden: 'Bu işlem için yetkiniz yok.',
  not_found: 'Kayıt bulunamadı.',
  merchant_market_required: 'En az bir pazar seçin.',
  translation_base_locale:
    'Ana dil için çeviri tutulmaz; ürünün veya kategorinin kendi alanlarını düzenleyin.',
  market_country_mismatch:
    'Teslimat adresi seçili pazarın ülkesinde olmalı. Başka bir ülkeye gönderim için sayfanın üstünden o ülkeyi seçin.',
  tax_rate_missing:
    'Bu ülke için KDV oranı tanımlı olmadığından sipariş alınamıyor. Lütfen mağazayla iletişime geçin.',
  export_exempt_domestic: 'İhracat istisnası yalnızca yurt dışı pazarda seçilebilir.',
  hs_code_format: 'GTİP/HS kodu 6–12 haneli olmalı.',
  order_cancelled: 'İptal edilmiş sipariş için bu belge oluşturulamaz.',
  store_not_found: 'Bu alan adına bağlı bir mağaza yok.',
  conflict: 'İşlem mevcut bir kayıtla çakışıyor.',
  version_mismatch:
    'Bu kayıt siz düzenlerken başka biri tarafından değiştirildi. Sayfayı yenileyip tekrar deneyin.',
  validation_failed: 'Bazı alanlar hatalı.',
  bad_request: 'İstek geçersiz.',
  token_invalid: 'Bağlantı geçersiz veya süresi dolmuş.',
  no_organization: 'Hesabınız aktif bir işletmeye bağlı değil.',
  rate_limited: 'Çok fazla istek gönderildi. Biraz bekleyip tekrar deneyin.',
  idempotency_key_required: 'Bu işlem için Idempotency-Key başlığı zorunlu.',
  idempotency_conflict: 'Aynı Idempotency-Key farklı bir istekle kullanıldı.',
  idempotency_in_progress: 'Aynı istek şu anda işleniyor.',
  csrf_failed: 'Güvenlik doğrulaması başarısız. Sayfayı yenileyip tekrar deneyin.',
  internal: 'Beklenmeyen bir hata oluştu. Hata kodu: {{requestId}}',
  slug_taken: 'Bu kısa ad zaten kullanılıyor.',
  code_taken: 'Bu kod zaten kullanılıyor.',
  hostname_taken: 'Bu alan adı başka bir mağazada kayıtlı.',
  market_exists: 'Bu ülke/dil/para birimi kombinasyonu zaten var.',
  cannot_remove_default_market: 'Varsayılan pazar silinemez; önce başka bir pazarı varsayılan yapın.',
  already_member: 'Bu kişi zaten işletmenin üyesi.',
  last_owner: 'İşletmede en az bir aktif sahip kalmalıdır.',
  role_in_use: 'Bu rol {{count}} kullanıcıya atanmış; önce onların rolünü değiştirin.',
  role_name_taken: 'Bu isimde bir rol zaten var.',
  integration_not_available_yet: 'Bu entegrasyon {{phase}}. fazda eklenecek. Şu an anahtar girilemez.',
  integration_not_configured: 'Önce bağlantı bilgilerini kaydedin.',
  setup_step_locked: 'Bu adım {{phase}}. fazda açılacak.',
  invalid_email: 'Geçerli bir e-posta adresi girin.',
  file_too_large: 'Dosya çok büyük (en fazla {{maxMb}} MB).',
  file_type_not_allowed: 'Bu dosya türü yüklenemez.',
  template_name_taken: 'Bu adla bir şablon zaten var.',
  sku_pattern_no_token: 'Kalıpta en az bir jeton olmalı (ör. {marka}).',
  sku_pattern_unknown_token:
    'Kalıpta bilinmeyen jeton var. Kullanılabilenler: {marka} {kategori} {urun} {secenek} {sira}.',
  sku_pattern_invalid: 'Kalıpta yalnızca harf, rakam, jeton ve - _ . / kullanılabilir.',
  schedule_in_past: 'Yayın zamanı en erken 1 dakika sonrası olabilir.',
  schedule_too_far: 'Yayın en fazla 1 yıl sonrasına planlanabilir.',
  listing_already_published: 'Ürün bu mağazada zaten yayında.',
  bulk_too_many: 'Bir toplu işlemde en fazla {{max}} ürün olabilir. Süzgeci daraltın.',
  collection_not_manual: 'Kurallı koleksiyona ürün elle eklenemez; koleksiyonun kurallarını değiştirin.',
  lot_tracked: 'Bu varyantın stoku parti/SKT ile takip ediliyor; stok ekranından girin.',
  stock_below_reserved: 'Stok, siparişlere ayrılmış adetin altına düşürülemez.',
  lot_required: 'Bu depodaki stok lotlarda; işlem için lotu seçin (lotsuz bakiye için "Lotsuz stok").',
  import_not_finished: 'İçe aktarma henüz bitmedi; bitince yeniden deneyebilirsiniz.',
  import_nothing_to_retry: 'Yeniden denenecek ürün yok; tüm ürünler uygulandı.',
  import_json_invalid: 'JSON dosyası okunamadı. Dosyanın geçerli JSON olduğundan emin olun.',
  import_doc_field_invalid: 'Bu alanın değeri ürün belgesi şemasına uymuyor.',
  xml_invalid: 'XML dosyası okunamadı (biçim hatası).',
  xml_doctype_not_allowed: 'Güvenlik nedeniyle DOCTYPE veya ENTITY bildirimi içeren XML kabul edilmez.',
  column_map_invalid: 'Sütun eşleştirmesi okunamadı.',
  fx_same_currency: 'Kur bazlı fiyatta kaynak liste başka para biriminde olmalı.',
  rate_format: 'Kuru 34,1250 biçiminde, sıfırdan büyük ve en fazla 8 ondalıkla girin.',
  price_list_derived:
    'Bu liste kurdan türetiliyor; fiyatları temel listeden hesaplanır. Fiyatı temel listede değiştirin ya da listeyi elle fiyatlıya döndürün.',
  card_currency_unsupported: '{{provider}}, {{currency}} para biriminde kart ödemesi almıyor.',
  fx_base_missing: 'Kurdan türetilen listenin temel listesi bulunamadı.',
  fx_rate_unavailable:
    '{{currency}} için seçilen kur türünde TCMB kuru yok (henüz alınmadı ya da bu tür yayımlanmıyor). Kur uydurulmaz: başka kur türü seçin veya kurlar gelince yeniden hesaplayın.',
  fx_list_is_base: 'Bu liste başka listelerin temel listesi; kendisi kurdan türetilemez.',
  fx_not_configured: 'Bu liste kurdan türetilmiyor.',
  fx_base_self: 'Liste kendisinden türetilemez; başka bir temel liste seçin.',
  fx_base_derived: 'Temel liste kurdan türetilmiş olamaz; elle fiyatlı bir liste seçin.',
  country_format: 'Ülke kodu iki harf olmalı (ör. DE).',
  market_currency_mismatch: 'Pazarın para birimi listenin para birimiyle aynı olmalı.',
  customer_or_email_required: 'Kayıtlı bir müşteri seçin ya da misafir sipariş için e-posta girin.',
  discount_conflict: 'Kupon ve elle indirim birlikte kullanılamaz; birini seçin.',
  draft_only_field: 'Müşteri, kargo, indirim ve ödeme yöntemi yalnızca taslak siparişte değiştirilebilir.',
  order_closed: 'Sipariş kapandı (tamamlandı veya iptal edildi); değiştirilemez.',
  order_shipped: 'Sipariş kargoya verildi; ürünler ve adres artık değiştirilemez.',
  order_paid: 'Ödeme alındı; ürünler ve adetler değiştirilemez. Yalnızca adres ve not değiştirilebilir.',
  order_invoiced:
    'Siparişin faturası kesildi; ürünler ve fatura adresi değiştirilemez. Önce faturayı iptal edin.',
  order_payment_in_progress: 'Müşteri şu anda kartla ödüyor; ödeme sonuçlanmadan ürünler değiştirilemez.',
  payment_link_expired: 'Ödeme bağlantısının süresi doldu. Yeni bağlantı için satıcıyla iletişime geçin.',
  payment_link_cancelled: 'Bu ödeme bağlantısı iptal edildi. Güncel bağlantı için satıcıyla iletişime geçin.',
  payment_link_used: 'Bu bağlantıyla ödeme zaten yapıldı.',
  payment_link_closed: 'Sipariş artık ödeme beklemiyor (ödendi veya iptal edildi).',
  payment_link_amount_changed:
    'Sipariş tutarı bağlantı oluşturulduktan sonra değişti; yeni bağlantı gerekiyor.',
  payment_link_not_allowed:
    'Ödeme linki yalnızca peşin ödenecek (ödeme bekleyen veya taslak) ve tutarı sıfırdan büyük siparişte oluşturulabilir.',
  payment_link_not_found: 'Ödeme bağlantısı bulunamadı. Bağlantıyı eksiksiz kopyaladığınızdan emin olun.',
  card_payment_unavailable:
    'Kartla ödeme kurulu değil (Kurulum Gerekli): Ödemeler → Ödeme ayarlarından ödeme kuruluşunu bağlayın.',
  payment_in_progress: 'Bu sipariş için bir ödeme denemesi sürüyor. Birkaç dakika sonra yeniden deneyin.',
  preauth_not_supported: 'Ön provizyon yalnızca iyzico ile kullanılabilir ({{provider}} için seçenek yok).',
  no_authorized_payment: 'Bu siparişte tahsil edilmemiş ön provizyon yok.',
  exceeds_authorization:
    'Yeni toplam, kartta bloke edilen provizyon tutarını aşıyor; provizyondan fazla tutar çekilemez.',
  preauth_capture_failed:
    'Provizyon tahsil edilemedi: {{detail}}. Ödeme kuruluşu panelinden kontrol edin; gerekirse provizyonu bırakıp müşteriden yeniden ödeme alın.',
  preauth_release_failed: 'Provizyon bırakılamadı: {{detail}}. Ödeme kuruluşu panelinden kontrol edin.',
  release_authorization_first: 'Bu siparişte kartta bloke var: iptal için "Provizyonu bırak"ı kullanın.',
  order_line_unknown: 'Bu ürün satırı bu siparişte yok.',
  quantity_exceeds_remaining: 'Adet, gönderilmeyi bekleyen adetten fazla olamaz.',
  nothing_to_ship: 'Gönderilecek ürün kalmadı; siparişin tüm ürünleri kargoya verildi.',
  partial_shipment_not_for_cod:
    'Kapıda ödemeli sipariş bölünemez: tahsil edilecek tutar tek pakette olmalı. Tüm ürünleri birlikte gönderin.',
  order_partially_shipped:
    'Siparişin bir bölümü kargoya verildi. Kalan ürünleri "Kargoya ver" ile gönderin; siparişi iptal etmek için önce gönderileri iptal edin.',
  exchange_not_for_withdrawal:
    'Cayma hakkında ürün bedeli iade edilir; değişim için talep türü olarak kusurlu ürün, yanlış ürün veya diğer seçin.',
  exchange_requires_delivery: 'Değişim, sipariş size teslim edildikten sonra istenebilir.',
  exchange_variant_invalid:
    'Bu seçenekle değişim yapılamaz: aynı ürünün aynı fiyatlı, satıştaki bir seçeneğini seçin.',
  exchange_out_of_stock:
    'İstediğiniz seçenekten yeterli stok yok. Başka bir seçenek seçin veya para iadesi isteyin.',
  not_an_exchange: 'Bu talep bir değişim talebi değil.',
  exchange_not_approved: 'Değişim ürünü yalnızca onaylanmış değişim talebinde kargoya verilir.',
  exchange_ship_required:
    'Değişim talebi "Değişimi kargoya ver" ile tamamlanır: yeni ürün stoktan düşer ve müşteriye takip numarası gider.',
  partial_cancel_not_allowed:
    'Kısmi iptal yalnızca bir bölümü kargoya verilmiş (hazırlanıyor) siparişte yapılır. Hiç gönderilmemiş siparişi tamamen iptal edin.',
  nothing_to_cancel: 'İptal edilecek ürün yok; gönderilmeyi bekleyen ürün kalmadı.',
  address_city_unknown: 'İl listede yok; listeden seçin.',
  address_district_unknown: 'Bu ilçe seçilen ile ait değil; listeden seçin.',
  neighbourhood_unknown: 'Bu mahalle seçilen ilçede yok; listeden seçin.',
  point_outside_turkey: 'Konum Türkiye dışında görünüyor; enlem ve boylamı kontrol edin.',
  sales_point_location_used: 'Bu lokasyon için zaten bir satış noktası var.',
  sales_point_pin_manual: 'Bu noktanın pini elle girildi; adresten konum bulmak için önce pini silin.',
  needs_finder_id_format: 'Kimlik küçük harf, rakam, tire veya alt çizgiyle yazılmalı (en çok 40 karakter).',
  needs_finder_duplicate_id: 'Bu kimlik zaten kullanılıyor; her öğenin kimliği farklı olmalı.',
  needs_finder_unknown_area: 'Koşuldaki destek alanı tanımlı değil; alanı ekleyin veya koşuldan çıkarın.',
  needs_finder_unknown_answer: 'Koşuldaki soru veya seçenek tanımlı değil; listeden seçin.',
  needs_finder_product_missing: 'Ürün bulunamadı (silinmiş olabilir); başka bir ürün seçin.',
  needs_finder_promotion_missing:
    'Kampanya bu mağazada bulunamadı; bu mağazanın bir otomatik kampanyasını seçin.',
  needs_finder_draft_exists:
    'Bu mağazanın taslağı zaten var. Yeniden üretmek için "Taslağı yeniden üret"i kullanın; mevcut taslağın yerine geçer.',
  needs_finder_not_submitted:
    'Taslak incelemeye gönderilmemiş veya gönderildikten sonra değişmiş; önce incelemeye gönderin.',
  needs_finder_no_areas: 'En az bir destek alanı ekleyin.',
  needs_finder_no_rules: 'En az bir öneri kuralı ekleyin.',
  needs_finder_no_emergency_option:
    'En az bir acil durum seçeneği işaretleyin; acil durumda ziyaretçi veteriner hekime yönlendirilir.',
  needs_finder_pets_disabled: 'Dost kaydı bu mağazada kapalı.',
  needs_finder_pets_full: 'En çok 20 dost kaydedebilirsiniz; önce birini silin.',
  needs_finder_consent_required: 'Kaydetmek için açık rıza kutusunu işaretleyin.',
  needs_finder_report_days: 'Dönem 7, 30 veya 90 gün olabilir.',
  location_not_found: 'Lokasyon bu bayiye ait değil.',
  hours_overlap: 'Aynı gün için saat aralıkları çakışıyor.',
  hours_range: 'Kapanış saati açılıştan sonra olmalı.',
  time_format: 'Saat SS:DD biçiminde olmalı (ör. 09:00).',
  postal_code_format: 'Posta kodu 5 rakam olmalı (ör. 34710).',
  postal_code_city_mismatch: 'Posta kodu seçilen ile ait değil: ilk iki rakam ilin plaka kodudur.',
  month_format: 'Ay YYYY-AA biçiminde olmalı (ör. 2026-10).',
  archive_year_required: 'Arşivde ay seçmek için yıl da verilmeli.',
  form_field_id: 'Alan kimliği yalnızca küçük harf, rakam ve alt çizgi içerebilir (en fazla 40).',
  form_label_required: 'Alanın etiketini yazın.',
  form_options_required: 'Seçim listesinde en az 2 seçenek olmalı.',
  form_options_duplicate: 'Seçenekler birbirinden farklı olmalı.',
  form_too_many_fields: 'Formda en fazla 20 alan olabilir.',
  form_field_duplicate: 'Aynı alan iki kez eklenmiş.',
  form_email_required: 'İletişim formunda yanıt verebilmek için zorunlu bir e-posta alanı olmalı.',
  form_privacy_notice_required: "Formu açmak için önce KVKK Aydınlatma Metni'ni yayımlayın (Yasal metinler).",
  form_disabled: 'Bu form şu anda kullanılamıyor.',
  form_field_required: 'Bu alan zorunlu.',
  form_value_invalid: 'Geçerli bir değer girin.',
  form_value_too_long: 'Metin çok uzun.',
  s3_endpoint_invalid: 'Nesne depolama uç noktası, kova adı veya anahtarlar eksik ya da hatalı.',
  s3_auth_failed: 'Nesne depolama anahtarları kabul edilmedi.',
  s3_bucket_missing: 'Nesne depolamada bu adla bir kova yok.',
  s3_unreachable: 'Nesne depolama sunucusuna ulaşılamadı.',
  s3_verify_failed: 'Nesne depolamaya yazılan deneme dosyası doğrulanamadı.',
  newsletter_unavailable: 'Bülten aboneliği şu anda kullanılamıyor.',
  newsletter_consent_required: 'Abone olmak için onay kutusunu işaretleyin.',
  newsletter_token_invalid:
    'Onay bağlantısı geçersiz veya süresi dolmuş. Bülten formundan yeniden abone olabilirsiniz.',
  unsubscribe_token_invalid: 'Bağlantı geçersiz. E-postadaki bağlantıyı eksiksiz açtığınızdan emin olun.',
  suppression_exists: 'Bu adres engel listesinde zaten var.',
  iys_auth_failed: 'İYS kullanıcı adı veya şifresi kabul edilmedi.',
  iys_invalid_settings: 'İYS bilgileri eksik: İYS kodu, marka kodu, kullanıcı adı ve şifre gerekli.',
  iys_rejected: 'İYS kaydı kabul etmedi; ayrıntı İYS kayıtları listesinde.',
  iys_unreachable: "İYS'ye ulaşılamadı. Daha sonra yeniden denenecek.",
  segment_rules_required: 'En az bir koşul ekleyin.',
  segment_condition_invalid: 'Koşul eksik veya geçersiz: alanı, karşılaştırmayı ve değeri kontrol edin.',
  segment_limit: 'En çok {{max}} segment oluşturulabilir. Kullanılmayanları silin.',
  segment_name_taken: 'Bu adla bir segment zaten var.',
  email_provider_not_live:
    "Bu sağlayıcı bağlı değil. Önce Entegrasyonlar'da bilgilerini girip bağlantıyı test edin.",
  ses_invalid_settings: 'Amazon SES bilgileri eksik.',
  ses_auth_failed: 'Amazon erişim anahtarları kabul edilmedi.',
  ses_unreachable: "Amazon SES'e ulaşılamadı.",
  ses_sending_disabled: 'Amazon SES hesabında gönderim kapalı.',
  sendgrid_invalid_settings: 'SendGrid bilgileri eksik.',
  sendgrid_auth_failed: 'SendGrid API anahtarı kabul edilmedi.',
  sendgrid_missing_scope: 'SendGrid API anahtarının e-posta gönderme izni yok.',
  sendgrid_unreachable: "SendGrid'e ulaşılamadı.",
  postmark_invalid_settings: 'Postmark bilgileri eksik.',
  postmark_auth_failed: 'Postmark sunucu anahtarı kabul edilmedi.',
  postmark_unreachable: "Postmark'a ulaşılamadı.",
  email_link_invalid:
    'Bağlantı adresi geçersiz. Mağaza içi bir yol (/kampanya) veya http(s) ile başlayan tam adres yazın.',
  email_block_duplicate: 'Aynı blok iki kez eklenmiş; sayfayı yenileyip tekrar deneyin.',
  test_recipient_not_staff:
    'Test e-postası yalnızca işletmenizin panel kullanıcılarına gönderilebilir (en çok 5 adres). Alanı boş bırakırsanız size gönderilir.',
  email_not_configured:
    'E-posta gönderimi kurulu değil (Kurulum Gerekli): Bağlantılar ekranından SMTP veya bir e-posta sağlayıcısı bağlayın.',
  email_image_unavailable: 'Görsel bulunamadı veya kullanılamıyor; görseli yeniden yükleyin.',
  email_products_source_missing: 'Seçilen ürün, koleksiyon veya kategori bulunamadı; kaynağı yeniden seçin.',
  campaign_audience_empty: 'En az bir segment seçin veya bülten abonelerini ekleyin.',
  campaign_segment_missing: 'Seçilen segmentlerden biri bulunamadı (silinmiş olabilir); listeyi yenileyin.',
  campaign_template_invalid: 'Bu mağazaya ait bir e-posta şablonu seçin.',
  campaign_subject_b_required: 'A/B testi için B konusunu yazın.',
  campaign_not_editable: 'Yalnızca taslak kampanya değiştirilebilir.',
  campaign_not_deletable: 'Gönderimi başlamış kampanya silinemez; rapor kayıt olarak kalır.',
  campaign_not_cancellable: 'Bu kampanyanın gönderimi zaten bitti veya durduruldu.',
  campaign_not_paused: 'Kampanya duraklatılmış değil.',
  campaign_schedule_invalid: 'Gönderim zamanı şimdiden sonra ve en çok 90 gün ileride olmalı.',
  campaign_no_recipients:
    'Bu kitlede gönderilebilir kimse yok (engel listesi, izin ve İYS denetiminden sonra).',
  template_review_required: 'Şablonda sağlık beyanı var ve uzman onayı bekliyor; onaylanmadan gönderilemez.',
  automation_email_required: 'Akışta en az bir e-posta adımı olmalı.',
  automation_wait_last: 'Akış bekleme adımıyla bitemez; son adımı silin veya ardına bir e-posta ekleyin.',
  automation_condition_invalid: 'Bu koşul bu akışta kullanılamaz.',
  automation_template_required: 'Akışı açmak için bu e-posta adımına bir şablon seçin.',
  birthday_invalid: 'Bu ayda böyle bir gün yok.',
  template_unavailable: 'Şablon kullanılamıyor (silinmiş veya uzman onayı bekliyor).',
  frequency_cap: 'Kişi yakın zamanda başka bir pazarlama e-postası aldı (sıklık sınırı).',
  stock_alerts_unavailable: 'Bu mağazada "Gelince haber ver" kullanılmıyor.',
  stock_alert_in_stock: 'Bu seçenek şu anda stokta; sepete ekleyebilirsiniz.',
  stock_alert_not_waiting: 'Bu talep artık beklemede değil (bildirildi veya kapandı).',
  price_drop_store_required:
    'Fiyat düşüşü bildirimi için fiyatların ve bağlantıların alınacağı mağazayı seçin.',
  products_unavailable: 'Ürünler e-postada gösterilemedi (yayından kaldırılmış veya onay bekliyor olabilir).',
  expired: 'Süresi doldu.',
  suppressed: 'Adres engel listesinde.',
  panel: 'Panelden iptal edildi.',
  rejected: 'E-posta sağlayıcısı iletiyi reddetti.',
  sms_template_in_use:
    'Bu SMS şablonu bekleyen bir kampanyada kullanılıyor; önce kampanyayı silin veya başka şablon seçin.',
  sms_not_configured:
    "SMS sağlayıcısı bağlı değil (Kurulum Gerekli): Entegrasyonlar'da Netgsm, İleti Merkezi veya Verimor'u bağlayın ve SMS ve WhatsApp ayarlarından seçin.",
  sms_mersis_required: "Ticari SMS'te MERSİS numarası zorunlu: İşletme bilgilerinden girin.",
  sms_opt_out_required: "Ticari SMS'te ret metni zorunlu: SMS ve WhatsApp ayarlarından girin.",
  sms_provider_not_connected:
    "Bu SMS sağlayıcısının canlı bağlantısı yok: önce Entegrasyonlar'da bağlayıp test edin.",
  sms_template_required: 'Bir SMS şablonu seçin.',
  whatsapp_not_configured: "WhatsApp Business bağlı değil (Kurulum Gerekli): Entegrasyonlar'dan bağlayın.",
  whatsapp_unreachable: 'WhatsApp (Meta) hizmetine ulaşılamadı. Daha sonra tekrar deneyin.',
  whatsapp_auth_failed: "WhatsApp erişim anahtarı kabul edilmedi: Entegrasyonlar'da yenileyin.",
  whatsapp_template_not_approved: "Bu WhatsApp şablonu Meta'da bulunamadı veya onaylı değil.",
  whatsapp_template_health_claim:
    'WhatsApp şablonunda veya değişkenlerde sağlık beyanı var; bu metinle gönderilemez. Hastalık önleme veya tedavi iddiası kullanılmaz.',
  whatsapp_template_required: 'Bir WhatsApp şablonu seçin veya adını ve dilini yazın.',
  whatsapp_params_mismatch: 'Girilen değişken sayısı şablondaki değişken sayısıyla aynı olmalı.',
  firebase_not_configured:
    "Firebase bağlı değil (Kurulum Gerekli): Entegrasyonlar'da Firebase hizmet hesabını bağlayın.",
  firebase_auth_failed: "Firebase hizmet hesabı reddedildi: Entegrasyonlar'da bilgileri yenileyin.",
  no_devices: 'Bu hesaba kayıtlı cihaz yok; önce Android yönetim uygulamasında bildirimleri açın.',
  quiet_hours_invalid: 'Sessiz saatin başlangıcı ve bitişi farklı olmalı.',
  web_push_key_required: 'Önce bildirim anahtarını oluşturun.',
  web_push_key_exists:
    'Anahtar zaten var; yenilemek için "Anahtarı yenile"yi kullanın (abonelikler sona erer).',
  web_push_unavailable: 'Bu mağazada tarayıcı bildirimleri şu an kullanılamıyor.',
  web_push_not_configured:
    'Vitrin bildirimleri kurulu değil (Kurulum Gerekli): anahtar oluşturup ayarı açın.',
  push_contact_required: 'Bildirimleri açmak için iletişim adresi gerekli.',
  push_contact_invalid: 'İletişim adresi mailto:ad@alan.adi veya https:// ile başlamalı.',
  push_endpoint_invalid: 'Tarayıcının bildirim adresi desteklenmiyor.',
  push_keys_invalid: 'Tarayıcının bildirim anahtarları geçersiz.',
  push_url_invalid: 'Mağaza içi bir adres yazın; / ile başlamalı (ör. /kategori/kedi).',
  promotion_tiers_invalid: 'Kademe eşikleri birbirinden farklı olmalı; adet kademesinde en az 1.',
  promotion_pay_invalid: '"Öde" adedi "al" adedinden az olmalı (ör. 3 al 2 öde).',
  promotion_currency_required: 'Tutar içeren kampanya için para birimi seçin.',
  promotion_not_editable: 'Yayındaki kampanya değiştirilemez; önce duraklatın.',
  promotion_not_deletable:
    'Yayına alınmış kampanya silinmez (fiyat geçmişi ve rapor için); duraklatabilirsiniz.',
  promotion_status_invalid: 'Kampanya bu işlem için uygun durumda değil.',
  promotion_ended: 'Kampanyanın bitiş tarihi geçmiş; tarihi güncelleyin.',
  coupon_not_combinable: 'Bu kupon sepetteki kampanyayla birlikte kullanılamaz.',
  order_promotions_locked:
    'Otomatik kampanyalı siparişin ürünleri değiştirilemez; siparişi iptal edip yeniden oluşturun.',
  gift_card_balance_negative: 'Bakiye sıfırın altına düşemez.',
  store_credit_insufficient: 'Mağaza kredisi bakiyesi yetersiz.',
  gift_card_not_found: 'Hediye kartı bulunamadı veya kullanılamıyor. Kodu kontrol edin.',
  gift_card_expired: 'Bu hediye kartının süresi dolmuş.',
  gift_card_currency: 'Bu hediye kartı bu mağazanın para biriminde değil.',
  gift_card_empty: 'Bu hediye kartında bakiye kalmamış.',
  store_credit_login_required: 'Mağaza kredisini kullanmak için giriş yapın.',
  gift_card_balance_changed: 'Hediye kartı bakiyesi değişti. Ödenecek tutarı kontrol edip yeniden deneyin.',
  store_credit_balance_changed:
    'Mağaza kredisi bakiyesi değişti. Ödenecek tutarı kontrol edip yeniden deneyin.',
  gift_card_missing: 'Ödemenin hediye kartı kaydı bulunamadı.',
  store_credit_no_customer: 'Mağaza kredisi yalnızca üye müşteriye verilebilir (misafir siparişi).',
  date_in_past: 'Tarih ileride olmalı.',
  not_zero: 'Tutar sıfır olamaz.',
  refund_order_not_paid:
    'Siparişin ödemesi tamamlanmadı. İade yerine siparişi iptal edin; hediye kartı/kredi bakiyesi kendiliğinden geri yüklenir.',
  store_credit_not_for_withdrawal:
    'Cayma hakkı iadesi müşterinin ödeme aracına yapılmalıdır; mağaza kredisi olarak verilemez.',
  store_credit_consent_required: 'İadeyi mağaza kredisi olarak vermek için müşterinin açık onayı gerekir.',
  loyalty_points_insufficient: 'Puan bakiyesi yetersiz (mevcut: {{points}} puan).',
  loyalty_points_limit: 'Puan bakiyesi üst sınırı aşılıyor.',
  loyalty_tier_name_duplicate: 'Bu seviye adı başka bir seviyede de kullanılıyor.',
  loyalty_tier_spend_duplicate: 'İki seviyenin harcama sınırı aynı olamaz.',
  loyalty_nothing_to_offer: 'Programı açmak için puan kazanma oranı veya en az bir seviye girin.',
  loyalty_login_required: 'Puan kullanmak için giriş yapın.',
  loyalty_unavailable: 'Sadakat puanı bu siparişte kullanılamıyor.',
  loyalty_min_redeem: 'Puan kullanmak için yeterli puanınız yok.',
  loyalty_points_changed: 'Puan bakiyeniz değişti; tutarı kontrol edip yeniden onaylayın.',
  order_loyalty_locked:
    'Sadakat seviyesi indirimli siparişin ürünleri değiştirilemez; siparişi iptal edip yeniden oluşturun.',
  referral_self: 'Kendi davet kodunuzu kullanamazsınız.',
  referral_not_first_order: 'Davet kodu yalnızca ilk siparişte kullanılabilir.',
  referral_percentage_max: 'Tavsiye indirimi en çok %50 olabilir.',
  referral_unavailable: 'Tavsiye programı şu anda kullanılamıyor.',
  referral_code_failed: 'Davet kodu oluşturulamadı; lütfen yeniden deneyin.',
  affiliate_source_format: 'Kaynak adı küçük harf, rakam, tire veya alt çizgiden oluşmalı (2–40 karakter).',
  affiliate_discount_taken: 'Bu kupon başka bir iş ortağına bağlı.',
  affiliate_source_taken: 'Bu kaynak adı başka bir iş ortağında kullanılıyor.',
  commission_not_approved: 'Yalnızca onaylanmış komisyonlar ödendi olarak işaretlenebilir.',
  ticket_number_failed: 'Talep numarası verilemedi; lütfen yeniden deneyin.',
  ticket_agent_invalid:
    'Talep yalnızca destek taleplerini yanıtlama yetkisi olan etkin bir çalışana atanabilir.',
  ticket_closed: 'Bu talep kapatıldı; yanıt yazılamaz. Yeni bir talep açabilirsiniz.',
  ticket_email_required: 'Mesajda e-posta adresi yok; talebe dönüştürülemez.',
  ticket_already_created: 'Bu mesaj zaten #{{number}} numaralı talebe dönüştürüldü.',
  ticket_order_not_found: 'Bu sipariş hesabınızda bulunamadı.',
  ticket_not_resolved: 'Talep çözüldükten sonra puan verebilirsiniz.',
  ticket_already_rated: 'Bu talebe zaten puan verdiniz.',
  macro_title_taken: 'Bu adla bir hazır yanıt zaten var.',
  support_report_days: 'Dönem 7, 30, 90 veya 365 gün olabilir.',
  chat_privacy_notice_required: 'Canlı sohbeti açmak için önce KVKK aydınlatma metnini yayımlayın.',
  chat_unavailable: 'Canlı destek şu anda kullanılamıyor.',
  chat_offline: 'Şu anda çevrimiçi temsilcimiz yok; mesaj bırakabilirsiniz.',
  chat_closed: 'Bu sohbet kapandı. Yeni bir sohbet başlatabilirsiniz.',
  chat_taken: 'Bu sohbeti başka bir çalışan üstlendi.',
  chat_ticket_exists: 'Bu sohbet zaten destek talebine dönüştürüldü.',
  chat_empty: 'Sohbette ziyaretçi mesajı yok; talebe dönüştürülemez.',
  ads_utm_source_format:
    'Kaynak adı 2–40 karakter olmalı; yalnızca küçük harf, rakam, nokta, tire ve alt çizgi.',
  ads_currency_unsupported: 'Bu para birimi desteklenmiyor.',
  ads_account_exists: 'Bu platformda aynı kimlikle bir reklam hesabı zaten var.',
  ads_import_columns:
    'Dosyada gerekli sütunlar bulunamadı: {{columns}}. Tarih, kampanya ve harcama sütunları gerekir.',
  ads_no_live_source:
    'Canlı reklam bağlantısı yok. Bağlantılar sayfasından Meta veya TikTok bağlantısını kurun.',
  ads_report_days: 'Dönem 7, 30 veya 90 gün olabilir.',
  ads_change_value_required: 'Bütçe değişikliği için tutar, yayın değişikliği için durum seçin.',
  ads_change_not_pending: 'Bu istek artık beklemede değil.',
  ads_change_not_approved: 'Yalnızca onaylanmış istek uygulandı olarak işaretlenebilir.',
  ads_change_self_approval: 'Kendi isteğinizi onaylayamazsınız; başka bir yetkili onaylamalı.',
  google_ads_conversion_action_format:
    'Dönüşüm işlemi customers/1234567890/conversionActions/123 biçiminde olmalı.',
  google_ads_cloud_project_not_approved:
    "Google Cloud projeniz Google Ads API ile yalnızca test hesaplarına erişebiliyor (Test erişimi). Gerçek reklam hesabı için Google Cloud'da Explorer erişimine başvurun: Google Cloud Console → Google Ads API → Genel bakış (Google bağlantısındaki OAuth istemcisinin projesi).",
  google_ads_user_permission_denied:
    "Bağlı Google hesabı bu Google Ads hesabına erişemiyor. Hesaba bir yönetici (MCC) hesabı üzerinden erişiyorsanız Entegrasyonlar → Google Ads'e MCC kimliğini girin; girdiyseniz bu hesabı yönettiğini kontrol edin.",
  google_ads_customer_not_enabled: 'Bu Google Ads hesabı henüz etkin değil ya da kapatılmış.',
  google_ads_authorization_error:
    "Google Ads yetkilendirmeyi reddetti. Cloud projesinin erişim düzeyi 9 Eylül 2026'dan sonra yükseltildiyse bu, Google'ın bildirdiği bilinen bir sorun olabilir: yeni bir Google Cloud projesi oluşturup Explorer erişimine başvurun.",
  google_ads_api_not_enabled:
    "Google Cloud projesinde Google Ads API etkin değil veya hizmet şartları kabul edilmemiş. Google Cloud Console'da Google Ads API'yi etkinleştirin.",
  google_ads_quota_exceeded:
    'Google Ads API istek sınırına ulaşıldı. Explorer erişiminde gerçek hesapta günlük işlem sınırı vardır; işlem daha sonra kendiliğinden yeniden denenir.',
  google_ads_access_prohibited:
    "Google Ads API erişimi bu Google Cloud projesi için engellenmiş. Google Cloud Console'da Google Ads API erişim düzeyini kontrol edin.",
  google_ads_action_not_permitted:
    'Bağlı Google hesabının bu Google Ads hesabında bu işlemi yapma yetkisi yok (yalnızca okuma erişimi olabilir). Hesaba Standart veya Yönetici erişimiyle bağlanın.',
  google_ads_account_suspended:
    "Google Ads hesabı askıya alınmış; işlem yapılamaz. Google Ads'te hesabın durumuna bakın.",
  google_ads_not_allowlisted:
    'Bu Google Ads özelliği hesabınız için açık değil (Google izin listesi gerekiyor).',
  google_ads_policy_violation:
    'Google reklam politikası nedeniyle reddedildi. Metni veya ürünü düzenleyin; sağlık ürünlerinde "tedavi eder", "önler", "iyileştirir" gibi ifadeler kullanılmaz. Ayrıntı kampanyanın politika durumunda.',
  google_ads_budget_too_low: 'Günlük bütçe Google Ads için çok düşük. Daha yüksek bir günlük bütçe girin.',
  google_ads_budget_too_high: 'Günlük bütçe Google Ads üst sınırını aşıyor.',
  google_ads_budget_currency: 'Bütçe tutarı hesabın para birimine veya en küçük birimine uymuyor.',
  google_ads_budget_invalid:
    'Google Ads bütçe ayarını reddetti. Bütçenin başka kampanyada kullanılmadığını ve silinmediğini kontrol edin.',
  google_ads_duplicate_name: 'Bu adla bir kampanya veya bütçe zaten var. Farklı bir ad girin.',
  google_ads_bid_out_of_range: 'Teklif tutarı Google Ads sınırlarının dışında.',
  google_ads_bidding_invalid: 'Seçilen teklif stratejisi bu kampanya türünde veya bütçeyle kullanılamıyor.',
  google_ads_temporary_error:
    'Google Ads geçici bir hata verdi. İşlem kısa süre sonra kendiliğinden yeniden denenir.',
  google_ads_resource_not_found:
    "Kaynak Google Ads'te bulunamadı (Google Ads ekranından silinmiş olabilir). Eşitleyip yeniden deneyin.",
  google_ads_value_out_of_range: 'Girilen değer Google Ads sınırlarının dışında.',
  google_ads_resource_limit: 'Google Ads hesabının kaynak sınırına ulaşıldı (ör. kampanya veya öğe sayısı).',
  google_ads_request_rejected: 'Google Ads isteği reddetti. Ayrıntı için Google bağlantı günlüğüne bakın.',
  google_ads_conversion_action_required: 'Dönüşüm yüklemeyi açmak için dönüşüm işlemini girin.',
  google_ads_not_linked:
    'Bu mağazaya Google Ads hesabı bağlı değil. Google bağlantıları sayfasında mağazanın Google Ads hesabını seçin.',
  google_ads_merchant_link_missing:
    'Merchant Center hesabı ile Google Ads hesabı birbirine bağlı değil. Bağlantıyı Merchant Center’dan isteyip Google Ads’te onaylayın.',
  google_ads_purchase_conversion_missing:
    'Google Ads hesabında etkin ve birincil bir “Satın alma” dönüşümü yok. Kampanyalar satın alma dönüşümüyle çalışır; önce dönüşüm izlemeyi kurun.',
  google_ads_campaign_removed: 'Kampanya kaldırıldı; artık değiştirilemez.',
  google_ads_not_draft: 'Yalnızca taslak kampanya düzenlenebilir veya silinebilir.',
  google_ads_operation_open:
    'Bu kampanyada bekleyen bir işlem var. Önce o işlemin sonucunu bekleyin veya işlemi iptal edin.',
  google_ads_already_created: 'Kampanya Google Ads’te zaten oluşturuldu.',
  google_ads_not_created: 'Kampanya henüz Google Ads’te oluşturulmadı. Önce taslağı onaya gönderin.',
  google_ads_already_enabled: 'Kampanya zaten yayında.',
  google_ads_not_enabled: 'Kampanya yayında değil.',
  google_ads_bidding_not_for_kind: 'Bu teklif stratejisi bu kampanya türünde kullanılamaz.',
  google_ads_target_not_for_bidding: 'Bu hedef seçilen teklif stratejisiyle kullanılamaz.',
  google_ads_end_before_start: 'Bitiş tarihi başlangıç tarihinden önce olamaz.',
  google_ads_no_change: 'Değer zaten aynı; değişiklik yok.',
  google_ads_operation_not_pending: 'Bu işlem artık onay beklemiyor.',
  google_ads_self_approval:
    'Kendi isteğinizi onaylayamazsınız; başka bir onay yetkilisi veya işletme sahibi onaylamalı.',
  google_ads_monthly_cap_missing:
    'Aylık reklam bütçesi tavanı tanımlı değil. Harcamaya yol açan işlemler tavan belirlenmeden onaylanamaz.',
  google_ads_monthly_cap_exceeded:
    'Tahmini aylık üst sınır, aylık reklam bütçesi tavanını aşıyor. Bütçeyi azaltın veya tavanı yükseltin.',
  google_ads_no_products: 'Kampanyada ürün yok. Yayına almadan önce ürün ekleyin.',
  google_ads_goal_not_applied:
    'Kampanyanın “Satın alma” dönüşüm hedefi henüz uygulanmadı. Birkaç dakika sonra yeniden deneyin.',
  google_ads_operation_not_open: 'Bu işlem iptal edilemez: uygulanıyor veya tamamlandı.',
  google_ads_no_drift: 'Google Ads ile fark yok.',
  google_ads_recommendation_invalid: 'Geçersiz Google önerisi.',
  google_ads_country_unsupported: 'Bu ülke hedefleme listesinde yok.',
  google_ads_language_unsupported: 'Bu dil hedefleme listesinde yok.',
  google_ads_daily_limit: 'Bugünkü Google Ads API işlem sınırına ulaşıldı; işlem yarın sabah uygulanacak.',
  google_ads_apply_interrupted:
    'Uygulama yarıda kesildi. Google Ads’te kampanyanın oluşup oluşmadığına bakın; oluşmadıysa yeniden isteyin.',
  google_ads_verify_mismatch:
    'Değişiklik Google Ads’e gönderildi ama geri okunan değer beklenenle aynı değil. Farkı kampanya sayfasında görün.',
  google_ads_invalid_status_change:
    'Bu durum değişikliği Google Ads’te yapılamaz (ör. kaldırılmış kampanya yeniden açılamaz).',
  google_ads_date_in_past: 'Geçmiş bir tarih seçilemez.',
  google_ads_start_date_locked: 'Yayına başlamış kampanyanın başlangıç tarihi değiştirilemez.',
  google_ads_recommendation_stale:
    'Bu Google önerisi artık geçerli değil (uygulanmış, kapatılmış veya güncellenmiş).',
  google_ads_basic_access_required:
    'Anahtar kelime önerisi için Google Ads API’de Basic erişim gerekli. Explorer erişiminde Google planlama hizmetlerini kapatır; Basic onayını Google’dan alın, sonra Google Ads ayarlarında erişim düzeyini “Basic” yapın.',
  google_ads_ad_rejected:
    'Google Ads reklam metnini reddetti (karakter sınırı, başlık/açıklama sayısı veya son URL). Metni düzenleyip yeniden isteyin.',
  google_ads_keyword_rejected:
    'Google Ads bir anahtar kelimeyi reddetti (çok uzun, çok fazla kelime veya geçersiz işaret). Listeyi düzenleyip yeniden isteyin.',
  google_ads_final_url_invalid: 'Son URL https:// ile başlayan geçerli bir adres olmalı.',
  google_ads_final_url_not_store:
    'Son URL mağazanın kendi alan adında olmalı (ör. ürün veya kategori sayfası).',
  google_ads_search_only: 'Reklam metni ve anahtar kelimeler yalnızca arama kampanyasında kullanılır.',
  google_ads_search_no_products:
    'Arama kampanyasına ürün eklenmez; reklam metni ve anahtar kelimelerle çalışır.',
  google_ads_keywords_min: 'En az bir anahtar kelime ekleyin.',
  google_ads_keywords_max: 'Anahtar kelime sayısı sınırı aşıldı.',
  google_ads_not_search: 'Bu işlem yalnızca arama kampanyasında yapılabilir.',
  google_ads_no_keywords: 'Kampanyada anahtar kelime yok. Yayına almadan önce anahtar kelime ekleyin.',
  google_ads_source_not_listed: 'Seçilen ürün veya kategori bu mağazanın vitrininde yayında değil.',
  google_ads_source_not_reviewed:
    'Bu ürünün sağlık içeriği veteriner onaylı değil; reklam taslağı üretilmez. Önce ürün metnini onaya gönderin.',
  google_ads_ideas_seed_required: 'Öneri için en az bir kelime veya açılış sayfası girin.',
  google_ads_text_review_not_pending: 'Bu reklam metni inceleme beklemiyor.',
  google_ads_headline_too_long: 'Başlık en çok 30 karakter olabilir.',
  google_ads_description_too_long: 'Açıklama en çok 90 karakter olabilir.',
  google_ads_headlines_min: 'En az 3 başlık girin.',
  google_ads_headlines_max: 'En çok 15 başlık olabilir.',
  google_ads_descriptions_min: 'En az 2 açıklama girin.',
  google_ads_descriptions_max: 'En çok 4 açıklama olabilir.',
  google_ads_path_too_long: 'Görünen yol parçası en çok 15 karakter olabilir.',
  google_ads_path_invalid: 'Görünen yolda yalnızca harf, rakam ve tire kullanılabilir.',
  google_ads_path2_without_path1: 'İkinci yol parçası için önce birinci parçayı girin.',
  google_ads_text_duplicate: 'Aynı metin iki kez kullanılamaz.',
  google_ads_too_many_pins:
    'Başlıkların çoğu sabitlenmiş: en az iki başlık sabitlenmemiş kalmalı ki Google çeşitleme yapabilsin.',
  google_ads_keyword_too_long: 'Anahtar kelime en çok 80 karakter olabilir.',
  google_ads_keyword_too_many_words: 'Anahtar kelime en çok 10 kelime olabilir.',
  google_ads_keyword_invalid_chars:
    'Anahtar kelimede Google’ın kabul etmediği bir işaret var (! @ % , * ? gibi).',
  google_ads_keyword_duplicate: 'Bu anahtar kelime aynı eşleme türüyle listede zaten var.',
  google_not_linked: 'Bu mağazaya bağlı bir Google kaynağı yok. Google bağlantıları sayfasından seçin.',
  ga4_report_days: 'Dönem 7, 28 veya 90 gün olabilir.',
  retention_confirm_required:
    'Otomatik imhayı açmak için süresi dolan kayıtların geri alınamaz şekilde silineceğini onaylayın.',
  retention_days_range: 'Süre bu veri türü için izin verilen aralıkta olmalı.',
  retention_log_days: 'Dönem 30, 90, 365 veya 1095 gün olabilir.',
  merchant_performance_days: 'Dönem 7, 28 veya 90 gün olabilir.',
  custom_event_name: 'Olay adı küçük harfle başlamalı; yalnızca a–z, rakam ve alt çizgi (3–40 karakter).',
  custom_event_reserved: 'Bu ad ayrılmış veya standart bir olayın adı; başka bir ad seçin.',
  custom_event_path:
    'Sayfa yolu / ile başlamalı (ör. /kampanya/ekim); başlangıç eşleşmesi için sonuna * ekleyin.',
  custom_event_path_required: 'Sayfa görüntüleme olayı için sayfa yolunu girin.',
  custom_event_destinations: 'En az bir ölçüm hizmeti seçin.',
  custom_event_duplicate: 'Aynı olay iki kez tanımlanmış.',
  storage_permission_denied:
    'Dosya kaydedilemedi: sunucudaki dosya deposuna yazma izni yok. Sistem yöneticisine iletin (hata kodu {{requestId}}).',
  storage_disk_full:
    'Dosya kaydedilemedi: sunucuda disk dolu. Sistem yöneticisine iletin (hata kodu {{requestId}}).',
  storage_read_only:
    'Dosya kaydedilemedi: sunucudaki dosya deposu salt okunur bağlanmış. Sistem yöneticisine iletin (hata kodu {{requestId}}).',
  storage_remote_failed:
    'Dosya kaydedilemedi: bağlı nesne deposuna (S3/R2) yazılamadı. Entegrasyonlar → Nesne depolama bağlantısını test edin (hata kodu {{requestId}}).',
  storage_write_failed:
    'Dosya kaydedilemedi: dosya deposuna yazılamadı. Sistem yöneticisine iletin (hata kodu {{requestId}}).',
  live_sandbox_skip_owner_only: 'Test ödemesi olmadan canlıya geçişi yalnızca işletme sahibi onaylayabilir.',
  review_not_purchased:
    'Bu ürünü değerlendirmek için ürünü bu mağazadan satın alıp teslim almış olmalısınız.',
  review_already_submitted: 'Bu ürünü daha önce değerlendirdiniz.',
  review_too_short: 'Değerlendirme en az 20 karakter olmalı.',
  review_rating_required: '1 ile 5 arasında bir puan seçin.',
  pdf_active_content:
    'Bu PDF etkin içerik (JavaScript, gömülü dosya veya program açma) içeriyor; vitrinde yayımlanamaz. Belgeyi "PDF olarak yazdır" ile yeniden kaydedip yükleyin.',
  video_url_invalid: 'Video adresi tanınmadı. YouTube veya Vimeo video adresini yapıştırın.',
  video_duplicate: 'Bu video zaten ekli.',
  document_file_invalid: 'Belge dosyası bulunamadı veya PDF değil; dosyayı yeniden yükleyin.',
  document_duplicate: 'Bu belge zaten ekli.',
  complementary_self: 'Ürün kendisinin tamamlayıcısı olamaz.',
  password_too_short: 'Şifre en az 12 karakter olmalı.',
  password_too_long: 'Şifre çok uzun.',
  password_too_common:
    'Bu şifre çok yaygın veya kolay tahmin edilir (sızmış şifre listelerinde geçiyor ya da adınızı içeriyor); birkaç kelime ve sayıdan oluşan daha uzun bir şifre seçin.',
  password_contains_email: 'Şifre e-posta adresinizi içermemeli.',
  required: 'Bu alan zorunlu.',
  in_past: 'Geçmiş bir tarih seçilemez.',
  import_already_applied: 'Bu içe aktarma zaten uygulandı.',
  import_preview_expired: 'Önizleme süresi doldu (1 saat). Dosyayı yeniden yükleyin.',
  import_file_missing: 'Bir dosya seçin.',
  import_file_too_large: 'Dosya çok büyük (en fazla {{maxMb}} MB).',
  import_file_unreadable: 'Dosya okunamadı. CSV veya Excel (.xlsx) dosyası yükleyin.',
  import_xls_unsupported: 'Eski Excel biçimi (.xls) desteklenmiyor. Dosyayı .xlsx veya CSV olarak kaydedin.',
  import_file_empty: 'Dosyada veri yok (ilk satır başlık olmalı).',
  import_too_many_rows: 'Dosyada en fazla {{max}} satır olabilir; dosyayı bölün.',
  column_missing: 'Zorunlu sütun eksik: {{column}}',
  dealer_key_column_missing: '"Bayi Kodu" veya "Vergi No" sütunlarından en az biri olmalı (eşleştirme için).',
  masked_value:
    'Maskeli değer (*** içeren) yüklenemez. Dosyayı kişisel verileri maskesiz görme yetkisiyle dışa aktarın veya hücreyi boş bırakın.',
  dealer_key_required: 'Bu satırda bayi kodu veya vergi no yok.',
  dealer_conflict: 'Bayi kodu ve vergi no farklı iki bayiyi gösteriyor.',
  dealer_group_required: 'Onaylı bayi için bir bayi grubu seçilmeli (bayi fiyatları bu gruptan gelir).',
  dealer_group_unknown: 'Bu isimde bayi grubu yok.',
  dealer_code_taken: 'Bu bayi kodu başka bir firmada kullanılıyor.',
  tax_number_registered: 'Bu vergi numarasıyla kayıtlı bir firma var.',
  tax_number_invalid: 'Vergi no (10 hane) veya T.C. kimlik no (11 hane) geçersiz.',
  tax_number_format: 'Vergi numarası biçimi geçersiz.',
  phone_format: 'Telefon numarası geçersiz (ör. 0532 123 45 67).',
  email_format: 'E-posta adresi geçersiz.',
  invalid_status_transition: 'Bu durumdan bu duruma geçilemez.',
  application_already_decided: 'Bu başvuru zaten sonuçlandı.',
  application_pending: 'Değerlendirmede olan bir başvurunuz var.',
  already_dealer: 'Hesabınız zaten bir bayi firmasına bağlı.',
  company_exists:
    'Bu vergi numarasıyla kayıtlı bir bayimiz var. Firmanızdaki yetkiliden sizi eklemesini isteyin veya bizimle iletişime geçin.',
  note_required: 'Açıklama yazılmalı.',
  payment_note_required: 'Ödemenin nasıl alındığını yazın (ör. havale dekont no, açık hesap).',
  consent_proof_required: 'İzin kaydı için belge/metin referansı girin (ör. imzalı form no).',
  customer_disabled: 'Müşteri hesabı devre dışı.',
  customer_anonymized:
    'Bu müşterinin kişisel verileri KVKK silme başvurusuyla anonimleştirildi; hesap düzenlenemez ve açılamaz.',
  privacy_export_limit: 'Verilerinizi 24 saatte en fazla 5 kez indirebilirsiniz. Lütfen daha sonra deneyin.',
  privacy_request_open: 'Açık bir silme başvurunuz var; sonuçlandığında e-postayla bildirilecek.',
  privacy_not_erasure: 'Anonimleştirme yalnızca silme başvurusunda yapılır.',
  privacy_request_closed: 'Başvuru sonuçlanmış; yeniden işlem yapılamaz.',
  privacy_already_anonymized: 'Bu kişinin verileri zaten anonimleştirilmiş.',
  privacy_store_credit_balance:
    'Müşterinin mağaza kredisi var ({{balances}}). Silmeden önce krediyi ödeyin veya müşterinin onayıyla sıfırlayın (Müşteriler → Mağaza kredisi).',
  privacy_subject_not_found:
    'Bu e-postayla kayıtlı müşteri hesabı veya sipariş bulunamadı; anonimleştirilecek veri yok. Başvuruyu açıklamayla sonuçlandırın.',
  privacy_open_orders:
    'Kapanmamış {{count}} sipariş var ({{numbers}}). Siparişler teslim edilip kapanmadan veya iptal edilmeden anonimleştirme yapılamaz.',
  privacy_open_returns: 'Sonuçlanmamış {{count}} iade talebi var; önce sonuçlandırın.',
  privacy_erasure_not_done:
    'Silme başvurusu ancak anonimleştirmeyle sonuçlanır. Yasal nedenle silinemiyorsa başvuruyu gerekçesiyle reddedin.',
  privacy_confirm_mismatch: 'Yazılan e-posta başvuranın e-postasıyla aynı değil.',
  date_in_future: 'Tarih ileri bir tarih olamaz.',
  domain_invalid: 'Geçerli bir alan adı girin (ör. zootopia.com.tr).',
  dkim_selector_invalid: 'DKIM seçicisi yalnızca harf, rakam, nokta, tire ve alt çizgi içerebilir.',
  date_too_old: 'Tarih bir yıldan eski olamaz.',
  email_registered: 'Bu e-posta adresiyle bir hesap var. Giriş yapın veya şifrenizi sıfırlayın.',
  account_activation_required:
    'Bu e-posta için hesabınız mağaza tarafından oluşturulmuş. "Şifremi unuttum" ile şifrenizi belirleyin.',
  password_incorrect: 'Mevcut şifre hatalı.',
  address_limit: 'En fazla {{max}} adres kaydedebilirsiniz.',
  file_invalid: 'Belge bulunamadı; yeniden yükleyin.',
  option_names_mismatch: 'Dosyadaki seçenek adları ürünün mevcut seçenekleriyle aynı değil.',
  title_required_for_new:
    'Yeni ürün için "Ürün Adı" gerekli (bu SKU sistemde yok; yalnızca güncelleme için sistemdeki SKU kullanılmalı).',
  wrong_file_products:
    'Bu dosya ürün listesine benziyor. Ürünleri Katalog → İçe / Dışa Aktarma → "Ürünler" bölümünden yükleyin.',
  wrong_file_dealers:
    'Bu dosya bayi listesine benziyor. Bayileri Katalog → İçe / Dışa Aktarma → "Bayi listesi" bölümünden yükleyin.',
  wrong_file_redirects:
    'Bu dosya yönlendirme listesine benziyor. Yönlendirmeleri İşletme → Yönlendirmeler → "Dosyadan içe aktar" ile yükleyin.',
  sku_missing:
    'SKU boş. Dosyada SKU girin ya da "Önerilen SKU\'larla yeniden önizle" ile parantezdeki öneriyi kullanın.',
  sku_generated: 'SKU önerildi',
  media_not_failed: 'Bu görsel "İndirilemedi" durumunda değil.',
  wrong_file_categories:
    'Bu dosya kategori listesine benziyor. Kategorileri Katalog → İçe / Dışa Aktarma → "Kategoriler" bölümünden yükleyin.',
  category_parent_unknown: 'Üst kategori bulunamadı (dosyada veya sistemde bu ad/kısa adla kategori yok).',
  category_parent_ambiguous: 'Bu adla birden çok kategori var; üst kategoriyi kısa adıyla yazın.',
  category_parent_has_errors: 'Üst kategorinin satırında hata var; bu satır da uygulanmaz.',
  category_status_unknown: 'Durum "etkin" veya "gizli" olmalı.',
  category_changed_during_import: 'Kategori önizlemeden sonra silindi; dosyayı yeniden yükleyin.',
  category_will_create: 'Kategori oluşturulacak',
  store_archive_live: 'Yayındaki mağaza doğrudan arşivlenemez; önce bakıma alın veya önizlemeye döndürün.',
  store_archived: 'Mağaza arşivde; önce arşivden çıkarın (önizlemeye döner).',
  store_not_draft: 'Yayındaki veya bakımdaki mağaza silinemez.',
  store_has_orders: 'Bu mağazanın siparişleri var; silinemez. Arşivleyebilirsiniz.',
  store_has_scoped_access:
    'Yalnızca bu mağazaya yetkili kullanıcı, davet veya API anahtarı var; önce onların mağaza kapsamını değiştirin.',
  confirm_code_mismatch: 'Yazılan kod mağaza koduyla aynı değil.',
  transfer_source_empty:
    'Kaynak depoda bu ürünün taşınabilir stoğu yok. İlk stok girişi için "Stok hareketi" → "Mal kabul" kullanın.',
  transfer_lot_required: 'Bu depodaki stok lotlarda; taşımak için kaynak olarak lotu seçin.',
  migration_package_invalid:
    'Dosya bir taşıma paketi değil veya bozuk. Staging panelinde "Taşıma paketini indir" ile alınan ZIP dosyasını yükleyin.',
  migration_package_too_large: 'Paket çok büyük (açılmış hâli en fazla 300 MB).',
  migration_file_missing: 'Paketteki bir görsel eksik ({{file}}); paketi yeniden indirin.',
  migration_file_corrupt: 'Paketteki bir görsel bozuk ({{file}}); paketi yeniden indirin.',
  store_scope_exceeds:
    'Kendi mağaza kapsamınızın dışına çıkamazsınız: yalnızca yetkili olduğunuz mağazaları verebilir ve bu mağazalardaki kullanıcıları yönetebilirsiniz.',
  member_self_update:
    'Kendi rolünüzü ve mağaza/bayi kapsamınızı değiştiremezsiniz; başka bir yetkili değiştirmelidir.',
  migration_file_type:
    'Paketteki bir dosyanın türü izin verilenlerden değil veya içeriği türüyle uyuşmuyor ({{file}}); yalnızca görsel ve PDF taşınır.',
  product_without_variant: 'Ürünün geçerli bir varyant (SKU) satırı yok.',
  sku_belongs_to_other_product: 'Bu SKU başka bir ürüne ait.',
  brand_required: 'Marka belirtilmeli (sütunda veya varsayılan marka seçerek).',
  brand_unknown: 'Bu isimde marka yok.',
  category_unknown: 'Bu isimde kategori yok; ürün kategorisiz eklendi.',
  species_unknown:
    'Tür tanınmadı. Kullanılabilir: kedi, köpek, kuş, kemirgen (hamster), tavşan, sürüngen (kaplumbağa), egzotik veya hepsi; birden çoğu virgülle.',
  tax_class_unknown: 'Bu oranda KDV sınıfı yok; önce KDV sınıfını tanımlayın.',
  visibility_unknown: 'Görünürlük "herkes", "perakende" veya "bayi" olmalı.',
  image_url_invalid: 'Görsel adresi https:// ile başlamalı.',
  duplicate_in_file: 'Bu değer dosyada {{row}}. satırda da var.',
  amount_format: 'Tutar okunamadı (ör. 1.299,90).',
  number_format: 'Sayı okunamadı.',
  currency_unknown: 'Para birimi belirlenemedi.',
  status_unknown: 'Durum "Onaylı", "Başvuru" veya "Askıda" olmalı.',
  too_long: 'Metin çok uzun.',
  too_many: 'Çok fazla değer (en fazla {{column}}).',
  options_required_for_multiple_variants: 'Birden çok varyant için seçenek (ör. Boyut) tanımlanmalı.',
  name_taken: 'Bu ad zaten kullanılıyor.',
  category_cycle: 'Kategori kendi alt kategorisinin altına taşınamaz.',
  category_has_children: 'Alt kategorisi olan kategori silinemez.',
  product_requires_active_variant: 'Etkin ürünün en az bir etkin varyantı olmalı.',
  vet_review_not_required: 'Bu ürünün sağlık içeriği yok; veteriner onayı gerekmez.',
  content_changed_during_review: 'İçerik siz incelerken değişti. Sayfayı yenileyip güncel içeriği inceleyin.',
  cannot_publish: 'Ürün yayınlanamaz: {{reasons}}',
  invalid_option: 'Seçenek değeri tanımlı değerlerden biri olmalı.',
  duplicate_combination: 'Aynı seçenek kombinasyonuna sahip iki varyant olamaz.',
  mismatch: 'Liste güncel değil; sayfayı yenileyin.',
  slug_format: 'Kısa ad yalnızca küçük harf, rakam ve tire içerebilir.',
  sku_format: 'SKU yalnızca harf, rakam ve . _ - / içerebilir.',
  barcode_format: 'Barkod 8–14 haneli olmalı.',
  sku_taken: 'Bu SKU başka bir varyantta kullanılıyor.',
  store_not_ready: 'Mağazanın satış pazarı (para birimi) tanımlı değil.',
  cart_line_limit: 'Sepette en fazla {{max}} farklı ürün olabilir.',
  variant_not_sellable: 'Bu ürün şu an satın alınamıyor.',
  insufficient_stock: 'Stokta yeterli ürün yok (en fazla {{available}}).',
  cart_empty: 'Sepetiniz boş.',
  empty: 'Sepetiniz boş.',
  cart_has_problems:
    'Sepetteki bazı ürünler satılamıyor, stokta yok veya bayi adet kuralına uymuyor; sepeti düzenleyin.',
  payment_setup_required:
    'Ödeme yöntemi henüz kurulmadı (Kurulum Gerekli). Sipariş için bizimle iletişime geçin.',
  login_required: 'Sipariş vermek için giriş yapın veya üye olun.',
  dealer_only: 'Şu an yalnızca bayilerimiz sipariş verebiliyor.',
  checkout_not_allowed: 'Sipariş şu an verilemiyor.',
  cart_changed: 'Sepet tutarı değişti (yeni toplam ekranda). Kontrol edip tekrar onaylayın.',
  refund_required: 'Ödenmiş sipariş, para iadesi yapılmadan iptal edilemez.',
  length: 'Metin uzunluğu geçersiz.',
  discount_code_taken: 'Bu kupon kodu zaten var.',
  discount_code_format: 'Kupon kodu 3–32 karakter; harf, rakam, - ve _ içerebilir.',
  percentage_max: "Yüzde indirim %100'ü aşamaz.",
  currency_required: 'Sabit tutarlı kupon için para birimi seçin.',
  ends_before_start: 'Bitiş, başlangıçtan sonra olmalı.',
  discount_not_found: 'Kupon kodu geçersiz.',
  discount_not_started: 'Bu kupon henüz geçerli değil.',
  discount_expired: 'Bu kuponun süresi dolmuş.',
  discount_usage_limit: 'Bu kuponun kullanım hakkı dolmuş.',
  discount_currency: 'Bu kupon sepetinizin para biriminde geçerli değil.',
  discount_not_eligible: 'Bu kupon hesabınız için geçerli değil.',
  discount_min_subtotal: 'Bu kupon için sepet tutarı yetersiz.',
  smtp_invalid_settings: 'SMTP ayarları eksik veya hatalı.',
  error_tracking_invalid_dsn: 'Hata takibi DSN biçimi hatalı.',
  error_tracking_failed: 'Hata takibi servisi deneme olayını kabul etmedi.',
  observability_invalid: 'Toplayıcı adresi veya kimlik başlıkları hatalı.',
  observability_failed: 'Toplayıcı deneme paketini kabul etmedi.',
  image_width: 'Görsel genişliği desteklenmiyor (160, 320, 480, 640, 960 veya 1280).',
  smtp_private_host_blocked: 'İç ağ adresindeki SMTP sunucusuna bağlanılamaz.',
  smtp_failed: 'SMTP bağlantısı başarısız.',
  number: 'Sayı girin.',
  unknown_field: 'Bilinmeyen alan.',
  not_supported: 'Bu seçenek desteklenmiyor.',
  non_zero_integer: 'Sıfırdan farklı tam sayı girin.',
  inactive: 'Kayıt pasif.',
  only_on_receipt: 'Lot yalnızca mal kabulde açılır.',
  must_be_positive: 'Pozitif bir sayı girin.',
  must_be_non_negative: 'Negatif olmayan bir sayı girin.',
  same_warehouse: 'Kaynak ve hedef depo aynı olamaz.',
  code_format: 'Kod biçimi geçersiz.',
  date_format: 'Tarih YYYY-AA-GG biçiminde olmalı.',
  etbis_url_invalid:
    "ETBİS bağlantısı Ticaret Bakanlığı'nın ETBİS adresi olmalı (https://etbis.eticaret.gov.tr/… veya https://etbis.ticaret.gov.tr/…).",
  days_pair_required: 'En az ve en çok süre birlikte girilmeli.',
  days_range_invalid: 'En az süre en çok süreden büyük olamaz.',
  crawl_in_progress: 'Bu mağaza için bir tarama zaten sırada veya sürüyor.',
  gtm_id_invalid: 'Google Tag Manager kimliği GTM-XXXXXXX biçiminde olmalı.',
  ga4_id_invalid: 'GA4 ölçüm kimliği G-XXXXXXXXXX biçiminde olmalı (eski UA- kimlikleri desteklenmez).',
  google_ads_id_invalid: 'Google Ads kimliği AW-123456789 biçiminde olmalı.',
  google_ads_label_invalid: 'Dönüşüm etiketi yalnızca harf, rakam, - ve _ içerebilir (6–40 karakter).',
  google_ads_id_required: 'Dönüşüm etiketi için önce Google Ads kimliğini girin.',
  meta_pixel_id_invalid: 'Meta piksel kimliği yalnızca rakamlardan oluşur (8–20 hane).',
  tiktok_pixel_id_invalid: 'TikTok piksel kimliği 10–30 harf ve rakamdan oluşur.',
  consent_action_mismatch: 'Çerez seçimi ile seçilen düğme uyuşmuyor.',
  google_client_not_configured:
    'Google OAuth istemcisi kurulmadı veya testi geçmedi (Kurulum Gerekli). Entegrasyonlar → Google hesabı (OAuth istemcisi).',
  google_not_connected: 'Google hesabı bağlı değil.',
  google_client_invalid: 'Google istemci kimliği veya gizli anahtarı kabul edilmedi.',
  google_client_invalid_format:
    'İstemci kimliği "….apps.googleusercontent.com" ile bitmeli; gizli anahtar boş olamaz.',
  google_reconnect_required:
    'Google erişimi geçersiz (hesaptan kaldırılmış veya süresi dolmuş). Google ekranından yeniden bağlanın.',
  google_signin_needs_domain:
    "Kurulum Gerekli: test, mağazanın gerçek dönüş adresiyle yapılır. Önce Mağazalar'dan bir vitrin alan adı ekleyin.",
  google_invalid_request:
    "Google isteği reddetti (invalid_request): {{description}} Denenen dönüş adresi: {{redirectUri}}. Adres gerçek bir alan adı ve https olmalı; Google Cloud'da istemcinin yetkili yönlendirme URI'leri arasında bulunmalı.",
  google_redirect_uri_mismatch:
    "Dönüş adresi Google Cloud'daki istemcide kayıtlı değil (redirect_uri_mismatch): {{redirectUri}}. Google Auth Platform → İstemciler → istemci → Yetkili yönlendirme URI'leri'ne ekleyin. {{description}}",
  google_client_rejected: 'Google isteği reddetti ({{error}}): {{description}}',
  google_unreachable: "Google'a ulaşılamadı. Daha sonra tekrar deneyin.",
  google_state_invalid:
    'Google dönüşü geçersiz veya süresi dolmuş (bağlantıyı başlatan kullanıcı 10 dakika içinde tamamlamalı). Yeniden bağlanın.',
  google_consent_denied: 'Google izin ekranında erişim verilmedi; bağlantı değişmedi.',
  google_auth_failed: 'Google bağlantısı tamamlanamadı. Yeniden deneyin; sürerse günlüğe bakın.',
  google_scope_missing: 'Bu hizmet için Google izni verilmedi. Hizmeti seçerek yeniden bağlanın.',
  google_api_error: 'Google hizmeti isteği reddetti veya yanıt vermedi. Günlüğe bakın.',
  google_permission_denied:
    'Bağlı Google hesabının bu kaynağa erişimi yok. Kaynağın (mülk, site, hesap) bu Google hesabıyla paylaşıldığını kontrol edin ya da erişimi olan hesapla yeniden bağlanın.',
  google_api_not_enabled:
    "Bu Google hizmetinin API'si Google Cloud projesinde etkin değil. Google Cloud Console → API'ler ve Hizmetler → Kitaplık'tan ilgili API'yi etkinleştirin (Google bağlantısındaki OAuth istemcisinin projesi).",
  google_quota_exceeded:
    'Google istek sınırına ulaşıldı. Biraz sonra yeniden deneyin; eşitlemeler kendiliğinden yeniden denenir.',
  google_resource_not_accessible: 'Bu kaynak bağlı Google hesabının erişebildiği listede yok.',
  store_has_no_domain: 'Mağazanın vitrin alan adı yok. Mağazalar ekranından alan adı ekleyin.',
  attribution_days: 'Dönem 7, 30, 90 veya 365 gün olmalı.',
  keyword_exists: 'Bu kelime havuzda zaten var.',
  keyword_target_path:
    'Hedef sayfa "/" ile başlayan bir vitrin yolu olmalı (ör. /urun/omega-3) ve boşluk içermemeli.',
  keyword_locale: 'Dil kodu iki harf olmalı (ör. tr).',
  keyword_required: 'Kelime boş olamaz.',
  pagespeed_not_configured:
    'PageSpeed Insights anahtarı girilmemiş veya testi geçmemiş. Entegrasyonlar → PageSpeed Insights.',
  web_vitals_in_progress: 'Bu mağaza için bir ölçüm zaten sürüyor. Bitince yeniden deneyin.',
  pagespeed_key_format: 'API anahtarı biçimi hatalı (Google Cloud → Kimlik bilgileri → API anahtarı).',
  pagespeed_key_invalid:
    'Google bu API anahtarını kabul etmedi. Anahtarda PageSpeed Insights API izni olmalı.',
  pagespeed_quota: 'PageSpeed Insights günlük kotası doldu. Yarın tekrar deneyin.',
  attribute_options_required: 'Seçenek türündeki özellikte en az bir seçenek olmalı.',
  attribute_options_duplicate: 'Aynı seçenek iki kez yazılmış.',
  attribute_name_taken: 'Bu adla bir özellik zaten var.',
  attribute_code_taken: 'Bu kısa kodla bir özellik zaten var.',
  attribute_type_locked:
    'Ürünlerde değeri girilmiş özelliğin türü değiştirilemez. Yeni bir özellik oluşturun veya değerleri temizleyin.',
  attribute_option_in_use: '"{{option}}" seçeneği ürünlerde kullanılıyor; önce o ürünlerde değiştirin.',
  attribute_in_collection:
    'Bu özellik "{{collection}}" koleksiyonunun kuralında kullanılıyor; önce kuraldan çıkarın.',
  attribute_duplicate: 'Aynı özellik iki kez girilmiş.',
  attribute_value_invalid: 'Değer bu özelliğin türüne uymuyor (sayı, seçenek veya evet/hayır).',
  collection_rules_required: 'Kurallı koleksiyonda en az bir koşul olmalı.',
  collection_condition_invalid: 'Koşul geçersiz: alanı, karşılaştırmayı ve değeri kontrol edin.',
  synonym_terms_min: 'Bir grupta en az iki farklı terim olmalı.',
  synonym_single_word: 'Her terim tek kelime olmalı (boşluk ve noktalama olmadan).',
  synonym_term_taken: '"{{term}}" başka bir eş anlamlı grubunda; bir terim tek grupta olabilir.',
  synonym_limit: 'En fazla 500 eş anlamlı grubu tanımlanabilir.',
  search_report_days: 'Dönem 7, 30 veya 90 gün olmalı.',
  pagespeed_unreachable: 'PageSpeed Insights’a ulaşılamadı. Daha sonra tekrar deneyin.',
  server_event_id_required:
    'Önce bu sağlayıcının kimliğini (ölçüm kimliği / piksel) Vitrin etiketleri bölümüne girin.',
  server_event_secret_required:
    'Sunucu olaylarını açmak için gizli anahtarı (API secret / erişim jetonu) girin.',
  server_test_code_required: 'Test için sağlayıcının "Test olayları" ekranındaki test kodunu girin.',
  server_event_not_retryable: 'Yalnızca başarısız veya atlanmış olay yeniden denenebilir.',
  server_secret_format: 'Gizli anahtar en az 8 karakter olmalı ve boşluk içermemeli.',
  server_test_code_format: 'Test kodu yalnızca harf, rakam, - ve _ içerebilir.',
  merchant_not_linked:
    'Bu mağaza için Merchant Center hesabı seçilmedi. Google bağlantıları → Mağaza kaynakları.',
  search_console_not_linked:
    'Bu mağaza için Search Console mülkü seçilmedi. Google bağlantıları → Mağaza kaynakları.',
  inspection_quota_exceeded: 'Bugünkü URL denetimi hakkı ({{limit}}) doldu. Yarın tekrar deneyin.',
  sitemap_not_in_property: 'Mağazanın alan adı seçilen Search Console mülkünün kapsamında değil.',
  url_not_in_property: 'Adres bu mağazanın alan adında ve seçilen Search Console mülkünde olmalı.',
  date_range_invalid: 'Bitiş tarihi başlangıçtan önce olamaz.',
  export_too_large: 'Bu dönemde {{max}} satırdan fazla kayıt var. Daha kısa bir dönem seçin.',
  unknown_role: 'Bilinmeyen rol.',
  unknown: 'Bilinmeyen değer.',
  unknown_brand: 'Bilinmeyen marka.',
  unknown_market: 'Bu pazar bu mağazaya ait değil.',
  mersis_format: 'MERSİS numarası 16 haneli olmalı.',
  hostname_format: 'Alan adı geçersiz (ör. zootopia.com.tr).',
  currency_locked: 'Fiyat girilmiş listenin para birimi değiştirilemez.',
  currency_mismatch: 'Para birimleri uyuşmuyor.',
  bulk_no_targets:
    'Seçime uyan ürün yok (fiyat işleminde: fiyatı olan ürün). Seçimi veya süzgeci değiştirin.',
  bulk_not_in_preview: 'Bu toplu işlem önizleme aşamasında değil.',
  bulk_preview_expired: 'Önizleme süresi doldu (30 dk). Yeniden önizleyin.',
  prices_changed_since_preview: 'Önizlemeden sonra fiyatlar değişti. Yeniden önizleyin.',
  bulk_not_applied: 'Bu toplu işlem uygulanmamış; geri alınamaz.',
  ledger_entry_not_reversible:
    'Bu kayıt ters çevrilemez. Sipariş kayıtları siparişin kendisinden düzelir (iptal, iade, düzenleme); ters kaydın tersi alınmaz.',
  ledger_entry_already_reversed: 'Bu kaydın ters kaydı zaten yapılmış.',
  date_invalid: 'Geçerli bir tarih girin.',
  report_period_too_long: 'Rapor dönemi en çok bir yıl olabilir.',
  balance_payment_unavailable:
    'Kartla ödeme şu anda kullanılamıyor. Bakiyenizi havale/EFT ile ödeyebilir veya satış temsilcinizle görüşebilirsiniz.',
  balance_payment_nothing_due: 'Ödenecek bakiye yok.',
  balance_payment_item_closed:
    'Seçtiğiniz kalemlerden biri kapanmış veya değişmiş. Sayfayı yenileyip yeniden seçin.',
  balance_payment_exceeds_balance: 'Tutar ödenecek bakiyeden fazla olamaz (en çok {{max}}).',
  balance_payment_too_small: 'Tutar en az 1,00 olmalı.',
  balance_payment_items_required: 'Ödenecek en az bir kalem seçin.',
  bank_import_columns:
    'Banka dökümünde tarih ve tutar (veya alacak) sütunları bulunamadı. Bankanızın hesap hareketleri dökümünü CSV veya Excel (XLSX) olarak indirin; gerekli sütunlar: {{required}}.',
  bank_line_not_found: 'Satır bu dökümde yok; önizlemeyi yeniden alın.',
  bank_line_blocked:
    'Bu satır deftere yazılamaz (tutar/tarih okunamadı, ileri tarih veya daha önce işlendi).',
  bank_line_duplicate: 'Bu banka hareketi daha önce deftere yazılmış.',
  bank_dealer_not_found: 'Seçilen bayi bulunamadı veya onaylı değil.',
  ledger_import_columns: 'Dosyada gerekli sütunlar yok: {{required}}. Şablondaki başlıkları kullanın.',
  ledger_import_not_in_preview: 'Bu aktarım önizleme aşamasında değil (uygulanmış veya süresi dolmuş).',
  ledger_import_expired: 'Önizleme süresi doldu (1 saat). Dosyayı yeniden yükleyin.',
  ledger_import_empty: 'Aktarılacak hatasız satır yok.',
  credit_limit_exceeded: 'Sipariş tutarı açık hesap kredi limitini aşıyor.',
  credit_overdue_block: 'Vadesi geçmiş borç olduğu için açık hesapla yeni sipariş verilemiyor.',
  credit_limit_currency:
    'Açık hesap kredi limiti başka bir para biriminde tanımlı; bu para biriminde açık hesapla sipariş verilemez.',
  quote_cart_locked:
    'Sepette kabul edilmiş bir teklif var; sepeti değiştirmek için önce teklifi sepetten çıkarın.',
  quote_closed: 'Bu teklif kapandı (siparişe dönüştü, reddedildi veya iptal edildi); değiştirilemez.',
  quote_not_acceptable: 'Bu teklif şu anda kabul veya ret için açık değil.',
  quote_expired: 'Teklifin geçerlilik süresi doldu. Yeni teklif için mağazayla iletişime geçin.',
  quote_unavailable:
    'Sepetteki teklif artık geçerli değil (iptal edildi veya kapandı). Teklifi sepetten çıkarın.',
  quote_changed: 'Teklif güncellendi; yeni sürümü görmek ve kabul etmek için teklif sayfasına gidin.',
  quote_lines_required: 'Teklifte en az bir ürün olmalı.',
  dealer_not_approved: 'Bayi onaylı değil veya bayi grubu yok.',
  quantity_below_minimum: 'Bu üründen bayi siparişinde en az {{min}} adet alınabilir.',
  quantity_not_multiple: 'Bu ürün {{step}} adetlik koli halinde satılır; adet koli adedinin katı olmalı.',
  min_order_not_met: 'Sepet tutarı bayi minimum sipariş tutarının altında.',
  reorder_nothing: 'Bu siparişte sepete eklenebilecek ürün yok.',
  company_viewer_cannot_order:
    'Hesabınız firmanızda "Yalnızca görüntüleme" yetkisinde; sipariş veremezsiniz. Siparişi firma Yetkilisi veya Satın alma kullanıcısı verebilir.',
  member_order_limit_exceeded:
    'Sipariş tutarı kullanıcı eşiğinizi aşıyor; bu tutardaki sipariş için firma Yetkilisinin onayı gerekir. Sepeti Yetkilinin onayına gönderebilir ya da küçültebilirsiniz.',
  approval_not_needed:
    'Bu sepet için firma onayı gerekmiyor; onaya yalnızca sipariş eşiği olan Satın alma kullanıcısı gönderir.',
  approval_already_granted: 'Sepet zaten onaylandı; siparişi tamamlayabilirsiniz.',
  approval_closed: 'Bu onay isteği zaten sonuçlandı.',
  approval_stale:
    'Sepet onaya gönderildikten sonra değişti; bu istek onaylanamaz. Satın alma kullanıcısı güncel sepeti yeniden göndermeli.',
  rejection_reason_required: 'Reddetmek için gerekçe yazın (en az 3 karakter).',
  po_number_required: 'Firmanız siparişte satın alma emri (PO) numarası istiyor.',
  po_document_required: 'Firmanız siparişte satın alma emri (PO) belgesi istiyor; belgeyi yükleyin.',
  po_number_format: 'PO numarasında kullanılamayan karakter var.',
  dealer_scope_role_incompatible:
    '"Yalnızca atanan bayiler" kapsamı bu rolle verilemez: rol, bayi kapsamı dışındaki verilere (ör. destek talepleri, pazarlama, denetim kaydı) erişim veriyor.',
  customer_email_taken: 'Bu e-posta başka bir müşteri hesabında kayıtlı.',
  dealer_scope_restricted:
    'Bu işlem tüm bayileri ilgilendirir; bayi kapsamınız "yalnızca atanan bayiler" olduğu için yapamazsınız.',
  region_name_taken: 'Bu adla bir bölge zaten var.',
  commission_later_period_exists:
    'Daha sonraki bir dönemin dökümü var; dönemler sırayla hesaplanır. Bu dönemdeki değişiklikler sonraki dönemde düzeltme olarak yer alır.',
  commission_statement_not_draft: 'Döküm taslak değil; onaylanmış veya ödenmiş döküm değiştirilemez.',
  commission_statement_not_approved: 'Ödendi işaretlemek için döküm önce onaylanmalı.',
  period_in_future: 'Henüz başlamamış dönem hesaplanamaz.',
  sales_user_invalid: 'Seçilen kullanıcı bu işletmenin bayileri görebilen etkin bir üyesi değil.',
  company_invite_mail_required:
    'Kurulum Gerekli: mağazanın e-posta altyapısı kurulmadığı için davet gönderilemiyor.',
  company_invite_limit: 'Bugünkü davet sınırına ({{max}}) ulaştınız; yarın yeniden deneyin.',
  company_invite_existing_account:
    'Bu e-posta adresiyle mağazada zaten bir hesap var. Bu kişiyi firmanıza eklemek için mağazayla iletişime geçin.',
  company_member_self:
    'Kendi rolünüzü değiştiremez, kendinizi firmadan çıkaramazsınız; bunun için mağazayla iletişime geçin.',
  company_member_already_active: 'Bu kullanıcı hesabını zaten etkinleştirdi.',
  company_link_limit: 'Bu kullanıcıya bugün en çok {{max}} bağlantı gönderilebilir; yarın yeniden deneyin.',
  company_last_owner: 'Firmada en az bir Yetkili kalmalı. Önce başka bir kullanıcıyı Yetkili yapın.',
  location_limit: 'Bir firmaya en çok {{max}} lokasyon eklenebilir.',
  reminder_confirm_required:
    'Vade hatırlatmasını açmak bayilerinize gerçek e-posta gönderir. Açmak için onay kutusunu işaretleyin.',
  must_be_after_start: 'Bitiş, başlangıçtan sonra olmalı.',
  net_quantity_unit_pair: 'Net miktar ve birimi birlikte girilmeli.',
  payment_method_unavailable: 'Bu ödeme yöntemi şu anda kullanılamıyor.',
  shipping_method_unavailable: 'Seçilen kargo yöntemi bu sepet için kullanılamıyor.',
  cod_not_available_for_shipping: 'Seçilen kargo yönteminde kapıda ödeme yok.',
  cod_limit_exceeded: 'Sipariş tutarı kapıda ödeme sınırını aşıyor.',
  legal_setup_required: 'Ön bilgilendirme formu ve mesafeli satış sözleşmesi yayımlanmadan sipariş alınamaz.',
  legal_changed: 'Sözleşme metinleri güncellendi. Lütfen yeni metni okuyup onaylayın.',
  payment_retry_not_allowed: 'Bu sipariş için yeniden ödeme yapılamaz.',
  use_payment_capture:
    'Sipariş "ödendi" durumuna yalnızca ödeme kaydıyla geçer ("Ödeme alındı" düğmesini kullanın).',
  payment_required_before_shipping: 'Ödemesi alınmamış sipariş kargoya verilemez.',
  bizimhesap_credentials_missing: 'BizimHesap firma kimliği (firmId) girilmemiş.',
  bizimhesap_auth_failed: 'BizimHesap bilgileri kabul edilmedi. Firma kimliğini/anahtarı kontrol edin.',
  bizimhesap_unreachable: "BizimHesap'a ulaşılamadı. Daha sonra tekrar deneyin.",
  bizimhesap_redirected:
    'BizimHesap isteği başka bir adrese yönlendirdi (HTTP {{status}} → {{location}}). BizimHesap API adresi değişmiş olabilir; platformun güncellenmesi gerekir.',
  bizimhesap_unexpected_response:
    'BizimHesap beklenmeyen bir yanıt verdi (HTTP {{status}}, {{contentType}}); yanıt JSON değil. Hizmet bakımda veya API adresi değişmiş olabilir.',
  bizimhesap_timeout: 'BizimHesap 20 saniye içinde yanıt vermedi. Daha sonra tekrar deneyin.',
  bizimhesap_api_error: 'BizimHesap isteği reddetti: {{message}}',
  bizimhesap_shape_unknown:
    'BizimHesap yanıtının alan yapısı tanınmadı ({{endpoint}}). Yanıt örneği kişisel veri maskelenerek BizimHesap sayfasında saklandı; alan eşlemesinin güncellenmesi gerekir.',
  invoice_provider_cancel_not_pending: 'Bu fatura için bekleyen bir BizimHesap iptali yok ({{state}}).',
  bizimhesap_customer_unmatched:
    'Bayi BizimHesap carisine bağlı değil ({{company}}). Entegrasyonlar → BizimHesap → Carileri içe aktar ile bağlayın; bilinmeyen kodla gönderilen fatura BizimHesap’ta yeni cari açardı.',
  bizimhesap_cash_unmapped:
    'Ödenmiş siparişin ödeme yöntemi için BizimHesap kasası seçilmemiş. Entegrasyonlar → BizimHesap → Kasa eşlemesi’nden seçin.',
  bizimhesap_cash_unknown: 'Bu kasa BizimHesap kasa listesinde yok. Önce kasa listesini yenileyin.',
  bizimhesap_write_confirm_required:
    'BizimHesap’a yazmayı açmak gerçek muhasebe hesabınızda kayıt oluşturur. Açmak için onay kutusunu işaretleyin.',
  bizimhesap_customer_not_found: 'Bu cari kodu BizimHesap cari listesinde yok.',
  bizimhesap_code_duplicate: 'Aynı cari kodu iki bayiye verilemez.',
  bizimhesap_code_taken: 'Bu cari kodu ({{code}}) başka bir bayiye bağlı.',
  bizimhesap_writes_disabled:
    'BizimHesap’a yazma kapalı. Sahip veya yönetici Entegrasyonlar → BizimHesap → BizimHesap’a yazma bölümünden açabilir.',
  bizimhesap_collection_not_sendable: 'Yalnızca bekleyen veya başarısız tahsilat gönderilebilir.',
  bizimhesap_collection_not_uncertain: 'Yalnızca sonucu belirsiz tahsilat çözülebilir.',
  bizimhesap_correction_not_found: 'Seçilen fatura düzeltme listesinde yok.',
  invoice_not_allowed: 'Bu sipariş için fatura oluşturulamaz (taslak veya iptal edilmiş).',
  invoice_exists: 'Bu siparişin geçerli bir faturası zaten var.',
  invoice_not_sendable: 'Yalnızca taslak veya başarısız fatura gönderilebilir.',
  invoice_not_uncertain: 'Fatura "belirsiz" durumda değil.',
  invoice_not_cancellable: 'Bu fatura iptal edilemez.',
  legal_no_draft: 'Yayımlanacak taslak yok.',
  legal_unknown_variable: 'Metinde bu tür için tanımlı olmayan bir değişken var.',
  legal_required_variables_missing: 'Metinde zorunlu değişkenler eksik.',
  legal_placeholder_syntax: 'Değişken yazımı hatalı: {{alan.adı}} biçiminde yazın.',
  iyzico_credentials_missing: 'iyzico API anahtarı ve gizli anahtar girilmemiş.',
  iyzico_not_sandbox_key: 'Test ortamı için iyzico "sandbox-" ile başlayan test anahtarı gerekir.',
  iyzico_sandbox_key_in_live: 'Canlı ortama test (sandbox) anahtarı girilmiş.',
  iyzico_auth_failed: 'iyzico anahtarları kabul edilmedi.',
  iyzico_unreachable: "iyzico'ya ulaşılamadı. Daha sonra tekrar deneyin.",
  paytr_credentials_missing: 'PayTR mağaza no, mağaza anahtarı ve gizli tuz girilmemiş.',
  paytr_auth_failed: 'PayTR bilgileri kabul edilmedi.',
  paytr_unreachable: "PayTR'ye ulaşılamadı. Daha sonra tekrar deneyin.",
  stripe_ok: 'Stripe bağlantısı doğrulandı (bakiye okundu).',
  stripe_credentials_missing: 'Stripe gizli anahtarı ve bildirim imza anahtarı girilmemiş.',
  stripe_key_invalid:
    'Gizli anahtar "sk_" veya kısıtlı anahtar "rk_" ile başlamalı (yayınlanabilir "pk_" anahtarı değil).',
  stripe_not_test_key: 'Test ortamı için "sk_test_" ile başlayan test anahtarı gerekir.',
  stripe_test_key_in_live: 'Canlı ortama test anahtarı girilmiş ("sk_live_" gerekir).',
  stripe_webhook_secret_invalid:
    'Bildirim imza anahtarı "whsec_" ile başlamalı (Stripe → Webhooks → uç nokta).',
  stripe_mode_mismatch: 'Anahtarın ortamı (test/canlı) seçilen ortamla uyuşmuyor.',
  stripe_auth_failed: 'Stripe anahtarı kabul edilmedi.',
  stripe_unreachable: "Stripe'a ulaşılamadı. Daha sonra tekrar deneyin.",
  sipay_ok: 'Sipay bağlantısı doğrulandı (erişim anahtarı alındı).',
  sipay_credentials_missing: 'Sipay uygulama kimliği, uygulama gizli anahtarı ve mağaza anahtarı girilmemiş.',
  sipay_auth_failed: 'Sipay bilgileri kabul edilmedi.',
  sipay_unreachable: "Sipay'e ulaşılamadı. Daha sonra tekrar deneyin.",
  google_other_account_linked:
    'Bu e-postanın hesabı başka bir Google hesabına bağlı. O Google hesabıyla veya e-posta ve şifrenizle giriş yapın.',
  google_signin_unavailable: 'Google ile giriş bu mağazada açık değil. E-posta ve şifrenizle giriş yapın.',
  google_signin_state_invalid:
    'Google ile giriş isteğinin süresi doldu veya bu tarayıcıda başlatılmadı. "Google ile devam et" ile yeniden deneyin.',
  google_signin_denied: 'Google ile giriş iptal edildi.',
  google_signin_failed: 'Google ile giriş tamamlanamadı. Yeniden deneyin.',
  google_signin_client_invalid: 'Mağazanın Google giriş istemcisi kabul edilmedi. Mağazayla iletişime geçin.',
  google_token_invalid: 'Google kimlik bilgisi doğrulanamadı. Yeniden deneyin.',
  google_email_unverified:
    'Google hesabınızın e-posta adresi doğrulanmamış. E-posta ve şifrenizle üye olun veya giriş yapın.',
  google_dealer_not_allowed: 'Bayi hesapları Google ile giriş yapamaz. E-posta ve şifrenizle giriş yapın.',
  google_signin_account_disabled: 'Bu hesap kullanıma kapalı. Mağazayla iletişime geçin.',
  google_signin_retry:
    'Bu Google hesabıyla az önce başka bir işlem yapıldı. "Google ile devam et" ile yeniden deneyin.',
  google_signup_expired:
    'Google ile üyelik onayının süresi doldu. "Google ile devam et" ile yeniden başlayın.',
  google_signin_owner_only: 'Google ile girişi yalnızca işletme sahibi açabilir.',
  google_signin_not_configured:
    'Önce Entegrasyonlar → Google ile giriş bölümünde OAuth istemcisini kaydedip test edin.',
  google_timeout: 'Google zamanında yanıt vermedi. Yeniden deneyin.',
  password_required_before_unlink:
    'Google bağlantısını kaldırmadan önce hesabınıza bir şifre belirleyin; yoksa hesabınıza giremezsiniz.',
  google_reauth_required:
    'Güvenliğiniz için şifre belirlemeden önce Google ile yeniden giriş yapın; şifre, girişten sonraki 15 dakika içinde belirlenebilir.',
  privacy_password_required:
    'Bu işlem şifrenizle onaylanır. Hesabınız Google ile açıldığı için önce Hesabım → Bağlı hesaplar bölümünden bir şifre belirleyin.',
  dealer_application_password_required:
    'Bayilik başvurusu Google ile giriş yapılmış oturumda yapılamaz. E-posta ve şifrenizle giriş yapın (şifreniz yoksa Hesabım → Bağlı hesaplar bölümünden belirleyin).',
  geliver_credentials_missing: 'Geliver API anahtarı girilmemiş.',
  geliver_auth_failed:
    'Geliver API anahtarı kabul edilmedi. Anahtarı Geliver panelinde (API anahtarları) kontrol edin.',
  geliver_timeout: 'Geliver 30 saniye içinde yanıt vermedi. Daha sonra tekrar deneyin.',
  geliver_unreachable: "Geliver'e ulaşılamadı. Daha sonra tekrar deneyin.",
  geliver_unavailable:
    'Geliver şu an yanıt veremiyor (HTTP {{status}}). Birkaç dakika sonra tekrar deneyin; etiket iki kez satın alınmaz.',
  geliver_rejected: 'Geliver isteği reddetti: {{reason}}',
  geliver_unexpected_response: 'Geliver beklenmeyen bir yanıt verdi; işlem tamamlanmadı.',
  geliver_not_connected:
    'Geliver bağlı değil. Entegrasyonlar → Kargo → Geliver ile API anahtarını girip bağlantıyı test edin.',
  geliver_sender_required: 'Geliver gönderici adresi seçilmemiş. Kargo → Geliver bölümünden seçin.',
  geliver_sender_unknown: "Bu gönderici adresi Geliver'de bulunamadı.",
  geliver_cod_unsupported:
    'Kapıda ödemeli siparişler şimdilik Geliver ile gönderilemez; takip numarasıyla elle kargolayın.',
  geliver_domestic_only: 'Geliver ile yalnızca Türkiye içindeki adreslere gönderilebilir.',
  geliver_address_city_unknown: 'Teslimat adresindeki il tanınmadı. Sipariş adresini düzeltin.',
  geliver_address_district_required:
    'Teslimat adresinde ilçe yok veya ilçe bu ilde değil. Kargo firması ilçe ister; sipariş adresini düzeltin.',
  geliver_phone_required:
    'Teslimat adresinde geçerli telefon numarası yok. Kargo firması alıcının telefonunu ister.',
  geliver_shipment_mismatch: 'Bu Geliver gönderisi bu siparişe ait değil.',
  geliver_shipment_cancelled: 'Bu Geliver gönderisi iptal edilmiş. Teklifleri yeniden alın.',
  geliver_other_offer_accepted: "Bu gönderi için Geliver'de başka bir teklif zaten kabul edilmiş.",
  geliver_offer_unknown: 'Seçilen teklif bu gönderide yok. Teklifleri yenileyin.',
  geliver_not_a_geliver_shipment: 'Bu gönderi Geliver ile oluşturulmamış.',
  geliver_cancel_after_pickup:
    'Kargo firması paketi teslim aldıktan sonra iptal buradan yapılamaz; Geliver veya kargo firmasıyla görüşün.',
  geliver_cancel_via_provider:
    'Geliver ile etiketi alınmış gönderiyi "Geliver\'de iptal et" düğmesiyle iptal edin (etiket ücretinin iadesi Geliver\'de yapılır).',
  geliver_dimension_invalid: 'Ölçü 1–300 cm arasında tam sayı olmalı.',
  paypal_ok: 'PayPal bağlantısı doğrulandı (bildirim kaydı bulundu).',
  paypal_credentials_missing: 'PayPal istemci kimliği, gizli anahtar ve bildirim kimliği girilmemiş.',
  paypal_auth_failed: 'PayPal istemci kimliği veya gizli anahtarı kabul edilmedi.',
  paypal_webhook_not_found: 'Bu bildirim (webhook) kimliği PayPal uygulamanızda bulunamadı.',
  paypal_unreachable: "PayPal'a ulaşılamadı. Daha sonra tekrar deneyin.",
  reconcile_provider_error: 'Sağlayıcıdan işlem dökümü alınamadı.',
  payment_token_mismatch: 'Ödeme bilgisi eşleşmedi.',
  card_payment_required: 'Kartla ödenen siparişte ödeme yalnızca sağlayıcı doğrulamasıyla kesinleşir.',
  already_paid: 'Bu siparişin ödemesi zaten alınmış.',
  refund_exceeds_payment: 'İade tutarı, iade edilebilir tutarı aşıyor.',
  no_captured_payment: 'Bu siparişte alınmış ödeme yok.',
  refund_in_progress: 'Bu ödeme için sürmekte olan bir iade var.',
  // Ödemenin "işlem gerektiriyor" kalma nedenleri (panelde ödeme satırında gösterilir)
  amount_mismatch:
    'Sağlayıcının bildirdiği tutar sipariş tutarıyla uyuşmuyor. Sağlayıcı panelinden kontrol edin.',
  amount_unverified:
    'Sağlayıcı ödeme tutarını bildirmedi; ödeme doğrulanamadı. Sağlayıcı panelinden kontrol edin.',
  test_mode_payment:
    'PayTR bu işlemi test modunda yaptı; gerçek para alınmadı. PayTR panelinde "Canlı Mod" adımını tamamlayın, bu siparişi iptal edin.',
  provider_review:
    'Ödeme sağlayıcının dolandırıcılık incelemesinde. Sonuç saatte bir kontrol edilir; sipariş açık kalır.',
  provider_review_stale:
    'Sağlayıcı incelemesi 7 günde sonuçlanmadı. Sağlayıcı panelinden kontrol edip siparişi elle sonuçlandırın.',
  provider_unreachable:
    'Ödeme sağlayıcısına ulaşılamadığı için sonuç doğrulanamadı. Sağlayıcı panelinden kontrol edip siparişi elle sonuçlandırın.',
  payment_timeout: 'Ödeme süresi doldu; sipariş iptal edildi.',
  bank_transfer_timeout: 'Havale/EFT ödemesi süresinde gelmedi; sipariş iptal edildi.',
  redirect_from_invalid:
    'Eski adres geçersiz: "/" ile başlayan bir yol olmalı (ana sayfa ve sistem yolları yönlendirilemez).',
  redirect_host_invalid:
    'Kaynak alan adı geçersiz: "zootopiaglobal.com" gibi bir alan adı yazın veya tüm alan adları için boş bırakın.',
  redirect_to_invalid:
    'Yeni adres geçersiz: "/" ile başlayan bir yol veya https:// ile başlayan tam adres olmalı.',
  redirect_loop: 'Yeni adres eski adresle aynı; yönlendirme döngü oluşturur.',
  redirect_exists: 'Bu eski adres için zaten bir yönlendirme var.',
  redirect_import_columns: 'Dosyada "eski adres" ve "yeni adres" sütunları bulunamadı. Şablonu kullanın.',
  redirect_status_invalid: 'Kod 301 veya 302 olmalı.',
  redirect_duplicate_row: 'Bu eski adres dosyada birden fazla kez geçiyor.',
  redirect_import_has_errors: 'Dosyada {{count}} hatalı satır var; hiçbir satır kaydedilmedi.',
  store_status_use_launch:
    'Yayın durumu mağaza formundan değişmez; Mağaza ayrıntısı → Yayın durumu bölümünü kullanın.',
  store_launch_incomplete: 'Hazırlık listesinde eksik şart maddeler var; yayına almadan önce tamamlayın.',
  return_not_allowed: 'Bu sipariş için iade talebi oluşturulamaz (ödenmemiş veya iptal edilmiş sipariş).',
  return_already_open: 'Bu sipariş için açık bir iade talebi var; sonuçlanmasını bekleyin.',
  return_line_invalid: 'Seçilen ürün bu siparişte yok.',
  return_quantity_exceeds: 'İade adedi sipariş edilen adetten fazla olamaz.',
  refund_not_pending: 'Bu iade zaten sonuçlanmış.',
  refund_still_running:
    'İade işlemi sürüyor olabilir. Elle sonuçlandırmak için başlatıldıktan sonra {{minutes}} dakika bekleyin.',
  store_live_requires_live_payments:
    'Mağaza yayındayken kart ödemesi test ortamına alınamaz. Önce mağazayı yayından kaldırın.',
  refund_note_required: 'Elle yapılan iade için açıklama girin (ör. iade edilen IBAN, tarih).',
  restock_only_after_shipping: 'Stoğa geri alma yalnızca kargolanmış siparişte yapılır.',
  card_provider_not_connected: 'Kart sağlayıcısının bu ortam için bağlantı testi başarılı olmalı.',
  live_requires_sandbox_payment: 'Canlıya geçmeden önce test ortamında en az bir başarılı ödeme alınmalı.',
  iban_taken: 'Bu IBAN zaten kayıtlı.',
  staging_allowlist: "Staging'de engellendi: alıcı e-posta izin listesinde değil.",
  mail_allowlist_entry_invalid:
    'Geçersiz giriş: tam e-posta adresi (ad@ornek.com) veya alan adı (@ornek.com) yazın.',
  iban_invalid: 'IBAN geçersiz (TR ile başlayan 26 karakter ve doğru kontrol hanesi).',
  tiers_not_ascending: 'Ağırlık kademeleri küçükten büyüğe sıralı olmalı.',
  shipment_closed: 'Bu gönderi kapanmış (teslim edildi/iade/iptal).',
  https_url_required: 'Adres https:// ile başlamalı.',
  shipping_setup_required: 'Kargo yöntemi tanımlanmadan sipariş alınamaz.',
  setup_step_required: 'Canlıya alma adımı atlanamaz; mağaza yayına alınınca kendiliğinden tamamlanır.',
  // F7-19: düzenli sipariş
  subscriptions_disabled: 'Bu mağazada düzenli gönderim kapalı.',
  product_not_subscribable: 'Bu ürün düzenli gönderimle satılmıyor.',
  subscription_interval_invalid: 'Bu gönderim sıklığı seçilemez; listedeki aralıklardan birini seçin.',
  subscription_address_required: 'Düzenli gönderim için Hesabım’a bir teslimat adresi ekleyin.',
  subscription_limit: 'En fazla 20 etkin düzenli gönderiminiz olabilir; birini iptal edip yeniden deneyin.',
  subscription_out_of_stock: 'Bu üründen istediğiniz adette stok yok; adedi azaltın veya daha sonra deneyin.',
  subscription_start_failed: 'Düzenli gönderim başlatılamadı; birazdan yeniden deneyin.',
  subscription_cancelled: 'Bu düzenli gönderim iptal edilmiş.',
  subscription_not_active: 'Bu işlem yalnızca etkin düzenli gönderimde yapılabilir.',
  subscription_not_paused: 'Yalnızca duraklatılmış düzenli gönderim sürdürülebilir.',
  subscription_postpone_range: 'Yeni tarih yarından itibaren en çok 12 hafta sonrası olabilir.',
  subscription_nothing_to_pay: 'Ödeme bekleyen sipariş yok.',
  customer_inactive: 'Müşteri hesabı etkin değil.',
  pricing_failed: 'Sipariş tutarı hesaplanamadı; birazdan yeniden deneyin.',
} as const;
